import { requireConfirmedEnrollmentStatus } from "../../utils/enrollmentStatus";
import { PAYMENT_LABELS, readEnrollmentPayment, paymentSummary, readImageAuthorization, readImageRestrictions } from "./enrollmentPayment";
import React, { useState, useEffect, useMemo, useRef } from "react";
import { 
  Container, 
  FormContainer,
  FieldRow,
  FieldGroup,
  FieldLabel,
  FieldInput,
  RadioGroup,
  ButtonContainer,
  ButtonGroup,
  FormDivider,
} from "./requerimentoStyles";
import { 
  Button, 
  Snackbar, 
  Alert,
  FormControl,
  FormControlLabel,
  Radio,
  Select,
  MenuItem,
  Typography,
  Box,
  Paper,
  TextField,
  Autocomplete,
  Checkbox,
  FormHelperText,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  List,
  ListItem,
  ListItemText,
} from "@mui/material";
import { Loading } from "../Loading/Loading";
import {
  setUpdateStudents,
  setUpdateFather,
  setUpdateMother,
  setEnrollmentContractStatus,
} from "../../api/sponteAPI";
import { NaturalidadeField, parseNaturalidade } from "./NaturalidadeField";
import { useEnrollmentStudents } from "./useEnrollmentStudents";
import { filterEnrollmentStudents, scalar } from "./enrollmentStudentSearch";
import { ANO_MATRICULA, TITULO_REQUERIMENTO } from "./enrollmentYear";
import papelTimbrado from "../../assets/PAPEL TIMBRADO_COMUNICADO.png";
import EnrollmentHealth from "./EnrollmentHealth";
import { readEnrollmentHealth } from "./enrollmentHealthModel";
import { RequerimentoSection, REQUIREMENT_SECTIONS, sectionForRequirementField, nextRequiredSection } from "./RequerimentoSections";
import PickupAuthorization from "./PickupAuthorization";
import { EMPTY_PICKUP, getAuthorizedPickupPeople, validatePickup, pickupPeopleSummary, readPickupFromObservation } from "./enrollmentPickup";
import { readRetiredEnrollmentFields } from "./enrollmentRetiredFields";
import { jsPDF } from "jspdf";
import { PDFDocument } from "pdf-lib";
import { logDebug } from "../../utils/logger";
import { contractPipeAnchorsFromTextItems } from "./contractPdfMarkers";

// Mapa de códigos de retorno da API Sponte
const SPONTE_ERROR_CODES = {
  1: "Operação Realizada com Sucesso.",
  2: "Parâmetros de busca inválidos.",
  3: "Tipo de parâmetro incorreto.",
  4: "Aluno já cadastrado.",
  5: "Data (Inválida).",
  6: "AlunoId (Inválido).",
  7: "ResponsavelID (Inválido).",
  8: "CursoID (Inválido).",
  9: "TurmaId (Inválido).",
  10: "ContratoID (Inválido).",
  11: "O aluno já está cadastrado na turma.",
  12: "DisciplinaId (Inválida).",
  13: "Tipo de plano inválido.",
  14: "Nº de parcelas inválido.",
  15: "Valor da parcela inválido.",
  16: "Forma de cobrança inválida.",
  17: "CategoriaID (Inválida).",
  18: "BolsaID (Inválida).",
  19: "ItemID (Inválido).",
  20: "CnabID (Inválido).",
  21: "Informe pelo menos um parâmetro de busca.",
  22: "Responsável já cadastrado.",
  23: "Cliente não possui token cadastrado para acesso a WSAPIEdu, entre em contato com o suporte.",
  24: "Cliente não encontrado, verifique o código do cliente informado.",
  25: "Token Inválido.",
  26: "Campo nome é obrigatório.",
  27: "Campo CPF é obrigatório.",
  28: "Já existe um cadastro com o nome informado.",
  29: "O CPF informado já está associado a outro cadastro.",
  30: "CPF inválido.",
  31: "Parentesco inválido.",
  32: "O CNPJ informado já está associado a outro cadastro.",
  33: "CNPJ inválido.",
  34: "Campo CNPJ é obrigatório.",
  35: "Tipo pessoa inválido. (1-Física / 2-Jurídica)",
  36: "Informe a data de término do contrato.",
  37: "A data de término do contrato deve ser maior que a data de início do contrato.",
  38: "Tipo de contrato inválido. (-1-Matrícula ou -2-Rematrícula)",
  39: "Tipo da matrícula inválido. (1-Turmas ou 2-Aulas Livres)",
  40: "Módulo inválido.",
  41: "Situação inválida.",
  42: "Contratante inválido.",
  43: "Nenhum registro foi encontrado para os parâmetros de busca informados.",
  44: "O parâmetro de busca deve conter o campo TurmaID.",
  45: "ContratoAulaLivreID (Inválido).",
  46: "ContaReceberID (Inválida).",
  47: "Somente parcela na situação Pendente podem ser editadas.",
  48: "Informe os itens da venda.",
  49: "Existem itens sem saldo, para realizar a venda informe o parâmetro Entregue com o valor zero, desta forma a venda será realiza sem a entrega dos itens.",
  50: "Existem notas lançadas para o contrato, por esse motivo não é possível alterar informações de disciplinas, curso ou turma.",
  51: "O parâmetro de busca deve conter o campo ContaReceberID.",
  52: "Nº da parcela inválido.",
  53: "E-mail inválido.",
  54: "Campo E-mail é obrigatório.",
  55: "ResponsavelDidaticoID (Inválido).",
  56: "ResponsavelFinanceiroID (Inválido).",
  57: "Número de requisições excedido.",
  58: "Aluno não matriculado na turma.",
  59: "Disciplina não encontrada.",
  60: "Período Inválido. Informe 1 para 1º Bimestre, 1º Trimestre, 1ºSemestre ou período único. Informe 2 para 2º Bimestre/Trimestre/Semestre. Informe 3 para 3º Bimestre/Trimestre. Informe 4 para 4º Bimestre.",
  61: "A nota informada é maior que a máxima permitida.",
  62: "Nota inválida.",
  63: "Aluno não matriculado na disciplina.",
  64: "Ano Letivo inválido.",
  65: "Curso sem matriz curricular vinculada.",
  66: "Informe o nome.",
  67: "Não é possível incluir turmas cíclicas para este curso. Só é possível incluir turmas cíclicas para cursos que pertençam ao tipo de curso \"Cursos Livres\", cujo TipoCursoId=-100",
  68: "Não é possível incluir turmas regulares para este curso. Só é possível incluir turmas regulares (com início e fim) para cursos que não pertençam ao tipo de curso \"Cursos Livres\", ou seja, TipoCursoId<>-100",
  69: "Cobrança de crédito recorrente em processamento do Educacional Web (Vindi).",
  70: "Tipo inválido (1 - Física / 2 - Jurídica).",
  71: "Informe o tipo de cadastro (Cliente / Fornecedor / Escola Aluno / Empresa Aluno).",
  72: "ClienteID (Inválido).",
  73: "ContaID (Inválido).",
  74: "Informe o sacado (AlunoID ou ClienteID).",
  75: "Número de matrícula já existe.",
  76: "Já existe um plano financeiro cadastrado neste contrato para o tipo de plano informado.",
  77: "Não foi possível gerar a linha digitável do boleto.",
  78: "Informe um Curso.",
  79: "FuncionarioID (Inválido).",
  80: "Deve ser informado ContaReceberID ou ContaPagarID maior que 0.",
  81: "Não pode ser informado ContaReceberID e ContaPagarID maior que 0, deve ser optado por apenas um.",
  82: "O plano informado para a quitação não possui nenhuma parcela pendente.",
  83: "A parcela informada para a quitação já encontra-se quitada.",
  84: "O valor pago informado é inválido.",
  85: "A forma de pagamento informada é inválida.",
  86: "Quantidade de vezes para o parcelamento do pagamento no cartão inválido.",
  87: "Operadora do cartão inválida.",
  88: "Bandeira do cartão inválida.",
  89: "Número do cartão inválido, deve ser informado apenas os últimos 4 dígitos do cartão.",
  90: "O período informado não pode ser superior à 6 meses.",
  91: "Data de início inválida.",
  92: "Data de término inválida.",
  93: "Informe o sacado (AlunoID, FornecedorID ou FuncionarioID).",
  94: "Informe apenas um sacado (AlunoID, FornecedorID ou FuncionarioID).",
  95: "FornecedorID (Inválido).",
  96: "ContaPagarID (Inválido).",
  97: "Informe a OperadoraID ou a bandeira do cartão.",
  98: "Informe a Turma ou o Curso.",
  99: "Informe apenas a Turma ou o Curso.",
  100: "Token já cadastrado.",
  101: "Usuário não encontrado.",
  102: "Parâmetros faltando ou inválidos - {detalhes}",
  103: "HorárioID (Inválido).",
  104: "Informe o Aluno.",
  105: "Não é possivel alterar o horário da turma pois a mesma já possui um quadro de horários gerado.",
  106: "Já existe uma turma cadastrada com este nome.",
  107: "O número máximo de integrantes da turma não pode ser menor que o número de alunos matriculados.",
  108: "Número do cartão inexistente.",
  109: "Operação Concluida Parcialmente.",
  110: "Turno Inválido.",
  111: "Modalidade Inválida.",
  112: "Ordem Inválida.",
  113: "O período informado não pode ser superior à 60 dias.",
  114: "Não existe aula gerada para os parâmetros informados.",
  115: "Número da aula inválido.",
  116: "O JSON informado não está em um formato válido.",
  117: "TipoCursoID inválido.",
  118: "SerieID inválido.",
  119: "Responsável já está compartilhado.",
  200: "Status OK",
  500: "Erro De Servidor - {detalhes}"
};

// Função para extrair o código de retorno da resposta XML da API Sponte
const extractSponteResponseCode = (xmlResponse) => {
  try {
    logDebug("🔍 Analisando resposta XML:", xmlResponse);
    
    // A resposta vem em formato XML, vamos procurar pelo código
    if (typeof xmlResponse === 'string') {
      // Padrão principal: <RetornoOperacao>código - mensagem</RetornoOperacao>
      const mainPattern = xmlResponse.match(/<RetornoOperacao>(\d+)\s*-\s*(.+?)<\/RetornoOperacao>/);
      if (mainPattern) {
        const code = parseInt(mainPattern[1]);
        const message = mainPattern[2].trim();
        logDebug(`✅ Código encontrado no formato padrão: ${code} - ${message}`);
        return { code, message };
      }
      
      // Padrão alternativo: <RetornoOperacao>apenas código</RetornoOperacao>
      const codeOnlyPattern = xmlResponse.match(/<RetornoOperacao>(\d+)<\/RetornoOperacao>/);
      if (codeOnlyPattern) {
        const code = parseInt(codeOnlyPattern[1]);
        logDebug("✅ Código encontrado (apenas número):", code);
        return { code, message: null };
      }
      
      // Padrão para mensagens longas sem código numérico no início
      const longMessagePattern = xmlResponse.match(/<RetornoOperacao>([^<]+)<\/RetornoOperacao>/);
      if (longMessagePattern) {
        const fullMessage = longMessagePattern[1].trim();
        logDebug("📝 Mensagem completa encontrada:", fullMessage);
        
        // Verificar se é uma mensagem de erro específica
        if (fullMessage.includes('Ocorreu um erro inesperado') || 
            fullMessage.includes('registro que está sendo editado sofreu alterações')) {
          logDebug("⚠️ Erro de concorrência/edição identificado (código 500)");
          return { code: 500, message: fullMessage };
        }
        
        if (fullMessage.includes('Operação Realizada com Sucesso') ||
            fullMessage.includes('Operacao Realizada com Sucesso')) {
          logDebug("✅ Sucesso identificado na mensagem");
          return { code: 1, message: fullMessage };
        }
        
        // Se chegou até aqui, é provavelmente um erro
        logDebug("❌ Mensagem de erro identificada (código 500)");
        return { code: 500, message: fullMessage };
      }
      
      // Padrão alternativo: <Codigo>código</Codigo>
      const altCodeMatch = xmlResponse.match(/<Codigo>(\d+)<\/Codigo>/);
      if (altCodeMatch) {
        const code = parseInt(altCodeMatch[1]);
        logDebug("✅ Código encontrado via tag Codigo:", code);
        return { code, message: null };
      }
      
      // Verificar se a resposta está vazia ou mal formada
      if (xmlResponse.trim().length === 0) {
        logDebug("❌ Resposta vazia (código 500)");
        return { code: 500, message: "Resposta vazia do servidor" };
      }
      
      // Se contém XML válido mas sem padrões reconhecidos, assumir erro
      if (xmlResponse.includes('<?xml') && xmlResponse.includes('DataTable')) {
        logDebug("❌ XML válido mas sem código reconhecível (código 500)");
        return { code: 500, message: "Resposta do servidor sem código de retorno" };
      }
    }
    
    // Se chegou até aqui, assumir sucesso apenas se não há indicações de erro
    logDebug("⚠️ Formato não reconhecido, assumindo sucesso (código 1)");
    return { code: 1, message: null };
  } catch (error) {
    console.error('❌ Erro ao extrair código da resposta:', error);
    return { code: 500, message: `Erro ao processar resposta: ${error.message}` };
  }
};

// Função para validar resposta da API Sponte
const validateSponteResponse = (response, operationType = 'atualização') => {
  const result = extractSponteResponseCode(response);
  const code = result.code;
  const isSuccess = code === 1;
  
  // Usar a mensagem extraída do XML se disponível, senão usar o mapa de códigos
  let message;
  if (result.message) {
    message = result.message;
  } else {
    message = SPONTE_ERROR_CODES[code] || `Código desconhecido: ${code}`;
  }
  
  logDebug(`📊 Validação da ${operationType}: Código ${code}, Sucesso: ${isSuccess}, Mensagem: ${message}`);
  
  return {
    isSuccess,
    code,
    message,
    userMessage: isSuccess 
      ? `Dados ${operationType === 'atualização' ? 'atualizados' : 'processados'} com sucesso!`
      : `Erro na ${operationType}: ${message}. Verifique os dados no Sponte.`
  };
};

export const Requerimento = () => {
  const [loading, setLoading] = useState(false);
  const [formSession, setFormSession] = useState(0);
  const [sectionOpenRequest, setSectionOpenRequest] = useState({ id: '', token: 0 });
  const validationRef = useRef(null);
  const advanceTimeoutRef = useRef(null);
  useEffect(() => () => clearTimeout(advanceTimeoutRef.current), []);
  const [showClearConfirmation, setShowClearConfirmation] = useState(false);
  const [formDataRaw, setFormDataRaw] = useState({
    // Dados Pessoais do Aluno
    nomeCompleto: "",
    dataNascimento: "",
    naturalidade: "",
    nacionalidade: "Brasileiro(a)",
    estado: "",
    cpf: "",
    rg: "",
    endereco: "",
    numeroEndereco: "",
    bairro: "",
    cidade: "",
    cep: "",
    complemento: "",
    telefones: "",
    emailResponsavel: "",
    escolaAnterior: "",
    anoSerie: "",
    nivel: "",
    turno: "",
    
    // Filiação - Dados dos Pais
    naoTemPai: false,
    idPai: "",
    nomePai: "",
    cpfPai: "",
    identidadePai: "",
    orgaoEmissorPai: "",
    dataNascimentoPai: "",
    estadoPai: "",
    enderecoPai: "",
    numeroEnderecoPai: "",
    complementoPai: "",
    cepPai: "",
    telefonePai: "",
    celularPai: "",
    bairroPai: "",
    cidadePai: "",
    emailPai: "",
    
    naoTemMae: false,
    idMae: "",
    nomeMae: "",
    cpfMae: "",
    identidadeMae: "",
    orgaoEmissorMae: "",
    dataNascimentoMae: "",
    estadoMae: "",
    enderecoMae: "",
    numeroEnderecoMae: "",
    complementoMae: "",
    cepMae: "",
    telefoneMae: "",
    celularMae: "",
    bairroMae: "",
    cidadeMae: "",
    emailMae: "",
    
    // Responsável Financeiro
    responsavelFinanceiro: "",

    // Responsável Pedagógico
    responsavelPedagogico: "",
    nomeResponsavel: "",
    cpfResponsavel: "",
    identidadeResponsavel: "",
    orgaoEmissorResponsavel: "",
    dataNascimentoResponsavel: "",
    estadoResponsavel: "",
    enderecoResponsavel: "",
    complementoResponsavel: "",
    cepResponsavel: "",
    telefoneResponsavel: "",
    bairroResponsavel: "",
    emailResponsavelFinanceiro: "",
    
    // Outros
    formaPagamento: "",
    contratoAssinado: false,
    corRaca: "",
    
    // Aspectos de Saúde e Autorizações
    utilizaMedicacao: "nao",
    medicacaoQual: "",
    doencaCongenita: "nao",
    doencaCongenitaQual: "",
    hipertensao: "nao",
    epilepsia: "nao",
    epilepsiaTratamento: "nao",
    hemofilia: "nao",
    diabetes: "nao",
    diabetesTratamento: "nao",
    asma: "nao",
    alergiaSubstancia: "nao",
    alergiaSubstanciaQual: "",
    alergiaAlimentar: "nao",
    alergiaAlimentarQual: "",
    planoSaude: "nao",
    planoSaudeQual: "",
    acompanhamentoEspecialista: "nao",
    acompanhamentoEspecialistaQual: "",
    
    // Autorizações
    ...EMPTY_PICKUP,
    autorizaSaidaSozinho: "nao",
    autorizaDireitoImagem: "",
    restricoesDireitoImagem: "",
    saidaAcompanhada: "nao",
    saidaAcompanhadaParentesco1: "",
    saidaAcompanhadaTelefone1: "",
    saidaAcompanhadaParentesco2: "",
    saidaAcompanhadaTelefone2: "",
    saidaAcompanhadaParentesco3: "",
    saidaAcompanhadaTelefone3: "",
    
    // Outros campos
    dataDevolucao: "",
    responsavelAssinatura: "",
  });

  const [error, setError] = useState(false);
  const [typeError, setTypeError] = useState("success");
  const [errorMessage, setErrorMessage] = useState("");
  const [fieldErrors, setFieldErrors] = useState({});
  
  // Estado para controlar alerta de dados atualizados
  const [showUpdateAlert, setShowUpdateAlert] = useState(false);
  const [lastUpdateDate, setLastUpdateDate] = useState("");
  const [googleDriveLink, setGoogleDriveLink] = useState("");

	  // Estados para modal de confirmação do PDF
	  const [showPdfConfirmModal, setShowPdfConfirmModal] = useState(false);
	  const [pdfValidationResult, setPdfValidationResult] = useState(null);
	  const [showSignatureModal, setShowSignatureModal] = useState(false);
	  const [activeSignatureType, setActiveSignatureType] = useState("financial");
	  const [financialSignatureImageData, setFinancialSignatureImageData] = useState("");
	  const [pedagogicalSignatureImageData, setPedagogicalSignatureImageData] = useState("");
	  const [useFinancialSignatureForPedagogical, setUseFinancialSignatureForPedagogical] = useState(true);
  const [contractPdfFile, setContractPdfFile] = useState(null);
  const signatureCanvasRef = useRef(null);
  const signatureDrawingRef = useRef(false);
  const signatureLastPointRef = useRef(null);
  const signatureDprRef = useRef(1);
  const signatureRawInputRef = useRef(false);

  // Estados para modal de confirmação de atualização
  const [showUpdateConfirmModal, setShowUpdateConfirmModal] = useState(false);
  const [updateValidationResult, setUpdateValidationResult] = useState(null);
  
  const [searchValue, setSearchValue] = useState("");
  const [isPreMatricula, setIsPreMatricula] = useState(false);
  const {
    students, listLoading, listError, selectedStudent, setSelectedStudent,
    studentData, studentLoading, studentError, retryList, retryStudent,
    financialStatus, financialLoading, financialError,
  } = useEnrollmentStudents(isPreMatricula);
  const financialCheckDate = financialStatus?.checkedAt
    ? financialStatus.checkedAt.split('-').reverse().join('/')
    : '';

  const niveis = ["Educação Infantil", "Ensino Fundamental", "Ensino Médio"];
  const turnos = ["Manhã", "Tarde", "Integral"];

  const formatCPF = (value) => {
    const numbers = value.replace(/\D/g, "");
    if (numbers.length <= 3) return numbers;
    if (numbers.length <= 6)
      return `${numbers.slice(0, 3)}.${numbers.slice(3)}`;
    if (numbers.length <= 9)
      return `${numbers.slice(0, 3)}.${numbers.slice(3, 6)}.${numbers.slice(
        6
      )}`;
    return `${numbers.slice(0, 3)}.${numbers.slice(3, 6)}.${numbers.slice(
      6,
      9
    )}-${numbers.slice(9, 11)}`;
  };

  const formatCEP = (value) => {
    const numbers = value.replace(/\D/g, "");
    if (numbers.length <= 5) return numbers;
    return `${numbers.slice(0, 5)}-${numbers.slice(5, 8)}`;
  };

  // Função para formatar data (DD/MM/AAAA)
  const formatDate = (value) => {
    const numbers = value.replace(/\D/g, "");
    if (numbers.length <= 2) {
      return numbers;
    } else if (numbers.length <= 4) {
      return `${numbers.slice(0, 2)}/${numbers.slice(2)}`;
    } else {
      return `${numbers.slice(0, 2)}/${numbers.slice(2, 4)}/${numbers.slice(4, 8)}`;
    }
  };

  // Função para formatar telefone (XX) XXXXX-XXXX ou (XX) XXXX-XXXX
  const formatPhone = (value) => {
    const numbers = value.replace(/\D/g, "");
    if (numbers.length <= 2) {
      return numbers;
    } else if (numbers.length <= 6) {
      return `(${numbers.slice(0, 2)}) ${numbers.slice(2)}`;
    } else if (numbers.length <= 10) {
      return `(${numbers.slice(0, 2)}) ${numbers.slice(2, 6)}-${numbers.slice(6)}`;
    } else {
      return `(${numbers.slice(0, 2)}) ${numbers.slice(2, 7)}-${numbers.slice(7, 11)}`;
    }
  };

  // Função helper para garantir que valores sejam sempre strings (evita undefined em inputs controlados)
  const ensureInputValue = React.useCallback((value) => {
    if (value === null || value === undefined) return '';
    if (typeof value === 'boolean' || typeof value === 'number') return value;
    return String(value || '');
  }, []);

  // Criar objeto formData normalizado que sempre retorna strings (previne warnings de controlled/uncontrolled)
  const formData = useMemo(() => {
    // Lista completa de todos os campos que devem existir (do estado inicial)
    const allFields = {
      nomeCompleto: '', dataNascimento: '', naturalidade: '', nacionalidade: 'Brasileiro(a)', estado: '',
      cpf: '', rg: '', endereco: '', numeroEndereco: '', bairro: '', cidade: '', cep: '', complemento: '',
      telefones: '', emailResponsavel: '', escolaAnterior: '', anoSerie: '', nivel: '', turno: '',
      naoTemPai: false, idPai: '', nomePai: '', cpfPai: '', identidadePai: '', orgaoEmissorPai: '',
      dataNascimentoPai: '', estadoPai: '', enderecoPai: '', numeroEnderecoPai: '', complementoPai: '',
      cepPai: '', telefonePai: '', celularPai: '', bairroPai: '', cidadePai: '', emailPai: '',
      naoTemMae: false, idMae: '', nomeMae: '', cpfMae: '', identidadeMae: '', orgaoEmissorMae: '',
      dataNascimentoMae: '', estadoMae: '', enderecoMae: '', numeroEnderecoMae: '', complementoMae: '',
      cepMae: '', telefoneMae: '', celularMae: '', bairroMae: '', cidadeMae: '', emailMae: '',
      responsavelFinanceiro: '', responsavelPedagogico: '', nomeResponsavel: '', cpfResponsavel: '',
      identidadeResponsavel: '', orgaoEmissorResponsavel: '', dataNascimentoResponsavel: '',
      estadoResponsavel: '', enderecoResponsavel: '', complementoResponsavel: '', cepResponsavel: '',
      telefoneResponsavel: '', bairroResponsavel: '', emailResponsavelFinanceiro: '', profissaoResponsavel: '',
      formaPagamento: '', contratoAssinado: false, corRaca: '', utilizaMedicacao: 'nao', medicacaoQual: '', doencaCongenita: 'nao',
      doencaCongenitaQual: '', hipertensao: 'nao', epilepsia: 'nao', epilepsiaTratamento: 'nao',
      hemofilia: 'nao', diabetes: 'nao', diabetesTratamento: 'nao', asma: 'nao', asmaTratamento: 'nao',
      alergia: 'nao', alergiaQual: '', alergiaTratamento: 'nao', alergiaSubstancia: 'nao', alergiaSubstanciaQual: '',
      alergiaAlimentar: 'nao', alergiaAlimentarQual: '', planoSaude: 'nao', planoSaudeQual: '', acompanhamentoEspecialista: 'nao', acompanhamentoEspecialistaQual: '',
      problemaVisao: 'nao', problemaAudicao: 'nao', problemaFala: 'nao', problemaLocomocao: 'nao', problemaAprendizagem: 'nao',
      problemaAprendizagemQual: '', problemaComportamento: 'nao', problemaComportamentoQual: '',
      medicamentoControlado: 'nao', medicamentoControladoQual: '', observacoes: '', observacoesSaude: '',
      observacoesPedagogicas: '', observacoesComportamentais: '', observacoesGerais: '', profissaoPai: '', profissaoMae: '',
      ...EMPTY_PICKUP, autorizaSaidaSozinho: 'nao', saidaAcompanhada: 'nao', saidaAcompanhadaParentesco1: '', saidaAcompanhadaTelefone1: '',
      saidaAcompanhadaParentesco2: '', saidaAcompanhadaTelefone2: '', saidaAcompanhadaParentesco3: '', saidaAcompanhadaTelefone3: ''
    };
    
    // Mesclar com formDataRaw, garantindo que todos os campos existam
    const normalized = { ...allFields, ...formDataRaw };
    
    // Garantir que todos os campos de string sejam sempre strings (nunca undefined ou null)
    Object.keys(normalized).forEach(key => {
      const value = normalized[key];
      if (typeof value === 'boolean' || typeof value === 'number') {
        // Manter booleanos e números como estão
        normalized[key] = value;
      } else {
        // Garantir que strings sejam sempre strings
        normalized[key] = ensureInputValue(value);
      }
    });
    
    return normalized;
  }, [formDataRaw, ensureInputValue]);

  const handleInputChange = (field, value) => {
    if (typeof value === "boolean") {
      if (field === "retiradaPai" || field === "retiradaMae") {
        setFieldErrors(previous => ({ ...previous, [field]: false, retiradaAutorizados: false }));
      }
      setFormDataRaw((prev) => ({ ...prev, [field]: value,
        ...(field === "naoTemPai" && value ? { retiradaPai: false } : {}),
        ...(field === "naoTemMae" && value ? { retiradaMae: false } : {}),
      }));
      return;
    }
    // Garantir que value seja sempre string antes de processar
    const stringValue = ensureInputValue(value);
    let formattedValue = stringValue;
    
    if (field.includes("cpf")) {
      formattedValue = formatCPF(stringValue);
    } else if (field.includes("cep")) {
      formattedValue = formatCEP(stringValue);
    } else if (field.includes("data") || field.includes("Data")) {
      formattedValue = formatDate(stringValue);
    } else if (field.includes("telefone") || field.includes("celular") || field.includes("fone")) {
      formattedValue = formatPhone(stringValue);
    }
    
    setFormDataRaw((prev) => {
      const updated = {
        ...prev,
        [field]: ensureInputValue(formattedValue),
      };
      // Garantir que todos os campos de string sejam sempre strings (nunca undefined)
      Object.keys(updated).forEach(key => {
        if (typeof updated[key] === 'string' || updated[key] === null || updated[key] === undefined) {
          updated[key] = ensureInputValue(updated[key]);
        }
      });
      return updated;
    });

    // Limpar erro do campo quando o usuário começar a preenchê-lo
    if (fieldErrors[field]) {
      setFieldErrors((prev) => ({
        ...prev,
        [field]: false,
      }));
    }
  };

  useEffect(() => {
    clearForm();
    setShowUpdateAlert(false);
    setLastUpdateDate("");
    setGoogleDriveLink("");
    setErrorMessage("");
    // Limpar o formulário ao trocar ou remover a seleção.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedStudent]);

  useEffect(() => {
    if (studentData) fillFormWithStudentData(studentData);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [studentData]);

  // Função para preencher o formulário com os dados do aluno
  const fillFormWithStudentData = (data) => {
    logDebug("=== PREENCHENDO FORMULÁRIO ===");
    logDebug("Dados recebidos:", data);
    
    if (data) {
      // Começar com formulário limpo usando o estado inicial completo (garante que todos os campos existam)
      // Isso previne warnings de componente controlado/não controlado
      const updatedFormData = {
        nomeCompleto: "",
        dataNascimento: "",
        naturalidade: "",
        nacionalidade: "Brasileiro(a)",
        estado: "",
        cpf: "",
        rg: "",
        endereco: "",
        numeroEndereco: "",
        bairro: "",
        cidade: "",
        cep: "",
        complemento: "",
        telefones: "",
        emailResponsavel: "",
        escolaAnterior: "",
        anoSerie: "",
        nivel: "",
        turno: "",
        naoTemPai: false,
        idPai: "",
        nomePai: "",
        cpfPai: "",
        identidadePai: "",
        orgaoEmissorPai: "",
        dataNascimentoPai: "",
        estadoPai: "",
        enderecoPai: "",
        numeroEnderecoPai: "",
        complementoPai: "",
        cepPai: "",
        telefonePai: "",
        celularPai: "",
        bairroPai: "",
        cidadePai: "",
        emailPai: "",
        profissaoPai: "",
        naoTemMae: false,
        idMae: "",
        nomeMae: "",
        cpfMae: "",
        identidadeMae: "",
        orgaoEmissorMae: "",
        dataNascimentoMae: "",
        estadoMae: "",
        enderecoMae: "",
        numeroEnderecoMae: "",
        complementoMae: "",
        cepMae: "",
        telefoneMae: "",
        celularMae: "",
        bairroMae: "",
        cidadeMae: "",
        emailMae: "",
        profissaoMae: "",
        responsavelFinanceiro: "",
        responsavelPedagogico: "",
        nomeResponsavel: "",
        cpfResponsavel: "",
        identidadeResponsavel: "",
        orgaoEmissorResponsavel: "",
        dataNascimentoResponsavel: "",
        estadoResponsavel: "",
        enderecoResponsavel: "",
        complementoResponsavel: "",
        cepResponsavel: "",
        telefoneResponsavel: "",
        bairroResponsavel: "",
        emailResponsavelFinanceiro: "",
        profissaoResponsavel: "",
        formaPagamento: "",
        corRaca: "",
        utilizaMedicacao: "nao",
        medicacaoQual: "",
        doencaCongenita: "nao",
        doencaCongenitaQual: "",
        hipertensao: "nao",
        epilepsia: "nao",
        epilepsiaTratamento: "nao",
        hemofilia: "nao",
        diabetes: "nao",
        diabetesTratamento: "nao",
        asma: "nao",
        asmaTratamento: "nao",
        alergia: "nao",
        alergiaQual: "",
        alergiaTratamento: "nao",
        problemaVisao: "nao",
        problemaAudicao: "nao",
        problemaFala: "nao",
        problemaLocomocao: "nao",
        problemaAprendizagem: "nao",
        problemaAprendizagemQual: "",
        problemaComportamento: "nao",
        problemaComportamentoQual: "",
        medicamentoControlado: "nao",
        medicamentoControladoQual: "",
        observacoes: "",
        observacoesSaude: "",
        observacoesPedagogicas: "",
        observacoesComportamentais: "",
        observacoesGerais: ""
      };
      
      // Função auxiliar para garantir que valores sejam strings (evita undefined em inputs controlados)
      const ensureString = (value) => {
        if (value === null || value === undefined) return '';
        if (typeof value === 'string') return value;
        if (Array.isArray(value)) return value[0] || '';
        return String(value);
      };

      // Dados básicos do aluno (diretamente do objeto principal)
      if (data.Nome) {
        updatedFormData.nomeCompleto = ensureString(data.Nome);
        logDebug("✓ Nome preenchido:", updatedFormData.nomeCompleto);
      }
      
      // Mapear campos com diferentes possíveis nomes
      if (data.CPF || data.Cpf || data.cpf) {
        updatedFormData.cpf = ensureString(data.CPF || data.Cpf || data.cpf);
      }
      
      if (data.RG || data.Rg || data.rg) {
        updatedFormData.rg = ensureString(data.RG || data.Rg || data.rg);
      }
      
      // Mapear número do endereço do aluno
      if (data.NumeroEndereco || data.NumeroEnderecoAluno) {
        updatedFormData.numeroEndereco = ensureString(
          data.NumeroEndereco || data.NumeroEnderecoAluno
        );
        logDebug(
          "✓ Número do endereço do aluno preenchido:",
          updatedFormData.numeroEndereco
        );
      }
      
      // Mapear data de nascimento do aluno com logs detalhados
      logDebug("🔍 Verificando data de nascimento do aluno...");
      logDebug("DataNascimento:", data.DataNascimento);
      logDebug("DataNasc:", data.DataNasc);
      logDebug("DataNascimentoAluno:", data.DataNascimentoAluno);
      
      if (data.DataNascimento || data.DataNasc || data.DataNascimentoAluno) {
        const dataAluno =
          data.DataNascimento || data.DataNasc || data.DataNascimentoAluno;
        updatedFormData.dataNascimento = ensureString(dataAluno);
        logDebug("✓ Data de nascimento do aluno preenchida:", updatedFormData.dataNascimento);
      } else {
        logDebug("❌ Data de nascimento do aluno não encontrada");
      }
      
      // Cidade natal é independente da cidade do endereço residencial.
      const naturalidade = ensureString(
        data.CidadeNatal || data.CidadeNatalAluno || data.Naturalidade || data.NaturalidadeAluno || ""
      );
      const { cidade: cidadeNatal, uf: ufNatal } = parseNaturalidade(naturalidade);
      updatedFormData.naturalidade = ufNatal ? `${cidadeNatal}/${ufNatal}` : cidadeNatal;
      // Mapear nacionalidade do aluno
      if (data.Nacionalidade || data.NacionalidadeAluno || data.PaisNatal) {
        const nacionalidade =
          data.Nacionalidade || data.NacionalidadeAluno || data.PaisNatal;
        updatedFormData.nacionalidade = ensureString(nacionalidade);
        logDebug("✓ Nacionalidade do aluno preenchida:", updatedFormData.nacionalidade);
      } else {
        // Preencher automaticamente com "Brasileiro(a)" se não houver dados
        updatedFormData.nacionalidade = "Brasileiro(a)";
        logDebug(
          "✓ Nacionalidade preenchida automaticamente: Brasileiro(a)"
        );
      }
      
      if (data.Endereco || data.EnderecoAluno || data.Logradouro) {
        const enderecoCompleto =
          data.Endereco || data.EnderecoAluno || data.Logradouro;

          updatedFormData.endereco = ensureString(enderecoCompleto);
        updatedFormData.complemento = ensureString(data.ComplementoEndereco);
      }
      
      if (data.Bairro || data.BairroAluno) {
        updatedFormData.bairro = ensureString(data.Bairro || data.BairroAluno);
      }
      
      if (data.Cidade || data.CidadeAluno) {
        updatedFormData.cidade = ensureString(data.Cidade || data.CidadeAluno);
      }
      
      if (data.CEP || data.Cep || data.cep) {
        updatedFormData.cep = ensureString(data.CEP || data.Cep || data.cep);
      }
      
      if (data.Complemento || data.ComplementoAluno) {
        updatedFormData.complemento = ensureString(data.Complemento || data.ComplementoAluno);
      }
      
      if (data.Telefone || data.TelefoneAluno || data.Fone) {
        updatedFormData.telefones = ensureString(
          data.Telefone || data.TelefoneAluno || data.Fone
        );
      }
      
      if (data.Email || data.EmailAluno) {
        updatedFormData.emailResponsavel = ensureString(data.Email || data.EmailAluno);
      }
      
      // Dados escolares
      if (data.EscolaAnterior || data.EscolaAnteriorAluno) {
        updatedFormData.escolaAnterior = ensureString(
          data.EscolaAnterior || data.EscolaAnteriorAluno
        );
      } else {
        // Preencher automaticamente com COLÉGIO AUTÊNTICO se não houver dados
        updatedFormData.escolaAnterior = "COLÉGIO AUTÊNTICO";
        logDebug(
          "✓ Escola anterior preenchida automaticamente: COLÉGIO AUTÊNTICO"
        );
      }

      // Definir "autoriza saída sozinho" como "nao" por padrão
      updatedFormData.autorizaSaidaSozinho = "nao";
      logDebug(
        "✓ Campo 'autoriza saída sozinho' definido como 'nao' por padrão"
      );
      
      if (data.Serie || data.SerieAluno || data.AnoSerie) {
        updatedFormData.anoSerie = ensureString(
          data.Serie || data.SerieAluno || data.AnoSerie
        );
      }
      
      if (data.Nivel || data.NivelAluno) {
        updatedFormData.nivel = ensureString(data.Nivel || data.NivelAluno);
      }
      
      if (data.Turno || data.TurnoAluno) {
        updatedFormData.turno = ensureString(data.Turno || data.TurnoAluno);
      }

      updatedFormData.formaPagamento = data.enrollmentContractStatus?.paymentOption || readEnrollmentPayment(data);
      updatedFormData.contratoAssinado = [true, 1, "true", "1"].includes(data.enrollmentContractStatus?.contractSigned);
      updatedFormData.autorizaDireitoImagem = ensureString(data.enrollmentContractStatus?.imageAuthorization ?? readImageAuthorization(data));
      updatedFormData.restricoesDireitoImagem = ensureString(data.enrollmentContractStatus?.imageRestrictions ?? readImageRestrictions(data));

      // Mapear observações (campo importante para detectar atualizações)
      // O campo vem do Sponte como "Observacao" (singular)
      if (data.Observacao || data.Observacoes || data.ObservacoesAluno || data.observacoes) {
        const obsValue = data.Observacao || data.Observacoes || data.ObservacoesAluno || data.observacoes;
        updatedFormData.observacoes = ensureString(obsValue);
        logDebug("✓ Observações carregadas:", updatedFormData.observacoes);
      }
      
      // Dados dos responsáveis (se disponíveis)
      if (
        data.responsaveisCompletos &&
        Array.isArray(data.responsaveisCompletos)
      ) {
        logDebug("=== PROCESSANDO RESPONSÁVEIS COMPLETOS ===");
        logDebug(
          "Quantidade de responsáveis:",
          data.responsaveisCompletos.length
        );
        
        data.responsaveisCompletos.forEach((responsavel, index) => {
          if (responsavel) {
            logDebug(
              `🔍 Processando responsável ${index + 1}:`,
              responsavel
            );
            logDebug("📋 Dados disponíveis:", Object.keys(responsavel));
            logDebug("📋 Objeto responsável completo:", responsavel);
            
            // Identificar tipo baseado no parentesco retornado pela API
            // Usar parentescoReal se disponível, senão extrair do parentesco formatado
            let parentescoReal = "";
            if (responsavel.parentescoReal) {
              parentescoReal = ensureString(responsavel.parentescoReal);
            } else if (responsavel.parentesco) {
              // Extrair parentesco da string formatada "Nome - (Parentesco)"
              const parentescoFormatado = ensureString(responsavel.parentesco);
              const match = parentescoFormatado.match(/\(([^)]+)\)/);
              parentescoReal = match ? match[1] : parentescoFormatado;
            }
            
            // Normalizar parentesco para comparação (remover acentos e converter para minúsculas)
            const parentescoNormalizado = parentescoReal.toLowerCase()
              .normalize("NFD")
              .replace(/[\u0300-\u036f]/g, ""); // Remove acentos
            
            if (parentescoNormalizado.includes("pai")) {
              // Dados do pai
              
              // Sempre definir todos os campos, mesmo que vazios (evita undefined)
              updatedFormData.idPai = ensureString(
                responsavel.ResponsavelID ||
                responsavel.responsavelId ||
                responsavel.id ||
                ""
              );
              updatedFormData.nomePai = ensureString(responsavel.nome || "");
              updatedFormData.cpfPai = ensureString(responsavel.cpf || "");
              updatedFormData.identidadePai = ensureString(responsavel.rg || "");
              
              logDebug("✓ ID do pai:", updatedFormData.idPai);
              logDebug("✓ Nome do pai:", updatedFormData.nomePai);
              logDebug("✓ CPF do pai:", updatedFormData.cpfPai);
              logDebug("✓ RG do pai:", updatedFormData.identidadePai);
              // Mapear data de nascimento do pai com logs detalhados
              logDebug("🔍 Verificando data de nascimento do pai...");
              logDebug("dataNascimento:", responsavel.dataNascimento);
              logDebug(
                "DataNascimento (original):",
                responsavel.dadosCompletos?.DataNascimento
              );

              // Sempre definir todos os campos, mesmo que vazios (evita undefined)
              updatedFormData.dataNascimentoPai = ensureString(
                responsavel.dataNascimento ||
                responsavel.dadosCompletos?.DataNascimento ||
                ""
              );
              updatedFormData.enderecoPai = ensureString(responsavel.endereco || "");
              updatedFormData.complementoPai = ensureString(responsavel.complemento || "");
              updatedFormData.numeroEnderecoPai = ensureString(responsavel.numeroEndereco || "");
              updatedFormData.bairroPai = ensureString(responsavel.bairro || "");
              updatedFormData.cidadePai = ensureString(responsavel.cidade || "");
              updatedFormData.cepPai = ensureString(responsavel.cep || "");
              updatedFormData.telefonePai = ensureString(responsavel.telefone || "");
              updatedFormData.celularPai = ensureString(responsavel.celular || "");
              updatedFormData.emailPai = ensureString(responsavel.email || "");
              
              logDebug("✓ Data nascimento do pai:", updatedFormData.dataNascimentoPai);
              logDebug("✓ Endereço do pai:", updatedFormData.enderecoPai);
              logDebug("✓ Complemento do pai:", updatedFormData.complementoPai);
              logDebug("✓ Número do endereço do pai:", updatedFormData.numeroEnderecoPai);
              logDebug("✓ Bairro do pai:", updatedFormData.bairroPai);
              logDebug("✓ Cidade do pai:", updatedFormData.cidadePai);
              logDebug("✓ CEP do pai:", updatedFormData.cepPai);
              logDebug("✓ Telefone do pai:", updatedFormData.telefonePai);
              logDebug("✓ Celular do pai:", updatedFormData.celularPai);
              logDebug("✓ Email do pai:", updatedFormData.emailPai);
            } else if (
              parentescoNormalizado.includes("mae") ||
              parentescoNormalizado.includes("mãe")
            ) {
              // Dados da mãe
              
              // Sempre definir todos os campos, mesmo que vazios (evita undefined)
              updatedFormData.idMae = ensureString(
                responsavel.ResponsavelID ||
                responsavel.responsavelId ||
                responsavel.id ||
                ""
              );
              updatedFormData.nomeMae = ensureString(responsavel.nome || "");
              updatedFormData.cpfMae = ensureString(responsavel.cpf || "");
              updatedFormData.identidadeMae = ensureString(responsavel.rg || "");
              updatedFormData.dataNascimentoMae = ensureString(
                responsavel.dataNascimento ||
                responsavel.dadosCompletos?.DataNascimento ||
                ""
              );
              updatedFormData.enderecoMae = ensureString(responsavel.endereco || "");
              updatedFormData.complementoMae = ensureString(responsavel.complemento || "");
              updatedFormData.numeroEnderecoMae = ensureString(responsavel.numeroEndereco || "");
              updatedFormData.bairroMae = ensureString(responsavel.bairro || "");
              updatedFormData.cidadeMae = ensureString(responsavel.cidade || "");
              updatedFormData.cepMae = ensureString(responsavel.cep || "");
              updatedFormData.telefoneMae = ensureString(responsavel.telefone || "");
              updatedFormData.celularMae = ensureString(responsavel.celular || "");
              updatedFormData.emailMae = ensureString(responsavel.email || "");
              
              logDebug("✓ ID da mãe:", updatedFormData.idMae);
              logDebug("✓ Nome da mãe:", updatedFormData.nomeMae);
              logDebug("✓ CPF da mãe:", updatedFormData.cpfMae);
              logDebug("✓ RG da mãe:", updatedFormData.identidadeMae);
              logDebug("✓ Data nascimento da mãe:", updatedFormData.dataNascimentoMae);
              logDebug("✓ Endereço da mãe:", updatedFormData.enderecoMae);
              logDebug("✓ Complemento da mãe:", updatedFormData.complementoMae);
              logDebug("✓ Número do endereço da mãe:", updatedFormData.numeroEnderecoMae);
              logDebug("✓ Bairro da mãe:", updatedFormData.bairroMae);
              logDebug("✓ Cidade da mãe:", updatedFormData.cidadeMae);
              logDebug("✓ CEP da mãe:", updatedFormData.cepMae);
              logDebug("✓ Telefone da mãe:", updatedFormData.telefoneMae);
              logDebug("✓ Celular da mãe:", updatedFormData.celularMae);
              logDebug("✓ Email da mãe:", updatedFormData.emailMae);
            }
          }
        });
      }
      
      Object.assign(updatedFormData, readPickupFromObservation(updatedFormData.observacoes), readEnrollmentHealth(updatedFormData.observacoes));

      // Garantir que TODOS os campos do estado inicial existam e sejam strings (nunca undefined)
      // Isso previne warnings de componente controlado/não controlado
      const normalizedFormData = { ...updatedFormData };
      
      // Lista de todos os campos que devem ser strings (do estado inicial)
      const stringFields = [
        'nomeCompleto', 'dataNascimento', 'naturalidade', 'nacionalidade', 'estado',
        'cpf', 'rg', 'endereco', 'numeroEndereco', 'bairro', 'cidade', 'cep', 'complemento',
        'telefones', 'emailResponsavel', 'escolaAnterior', 'anoSerie', 'nivel', 'turno',
        'idPai', 'nomePai', 'cpfPai', 'identidadePai', 'orgaoEmissorPai', 'dataNascimentoPai',
        'estadoPai', 'enderecoPai', 'numeroEnderecoPai', 'complementoPai', 'cepPai',
        'telefonePai', 'celularPai', 'bairroPai', 'cidadePai', 'emailPai', 'profissaoPai',
        'idMae', 'nomeMae', 'cpfMae', 'identidadeMae', 'orgaoEmissorMae', 'dataNascimentoMae',
        'estadoMae', 'enderecoMae', 'numeroEnderecoMae', 'complementoMae', 'cepMae',
        'telefoneMae', 'celularMae', 'bairroMae', 'cidadeMae', 'emailMae', 'profissaoMae',
        'responsavelFinanceiro', 'responsavelPedagogico', 'nomeResponsavel', 'cpfResponsavel',
        'identidadeResponsavel', 'orgaoEmissorResponsavel', 'dataNascimentoResponsavel',
        'estadoResponsavel', 'enderecoResponsavel', 'complementoResponsavel', 'cepResponsavel',
        'telefoneResponsavel', 'bairroResponsavel', 'emailResponsavelFinanceiro', 'profissaoResponsavel',
        'corRaca', 'medicacaoQual', 'doencaCongenitaQual', 'alergiaQual',
        'problemaAprendizagemQual', 'problemaComportamentoQual', 'medicamentoControladoQual',
        'observacoes', 'observacoesSaude', 'observacoesPedagogicas', 'observacoesComportamentais',
        'observacoesGerais', 'autorizaDireitoImagem', 'restricoesDireitoImagem'
      ];
      
      // Garantir que todos os campos de string sejam sempre strings (nunca undefined ou null)
      stringFields.forEach(field => {
        if (!(field in normalizedFormData) || normalizedFormData[field] === null || normalizedFormData[field] === undefined) {
          normalizedFormData[field] = '';
        } else {
          normalizedFormData[field] = ensureString(normalizedFormData[field]);
        }
      });
      
      // Garantir que campos booleanos sejam sempre booleanos
      if (normalizedFormData.naoTemPai === undefined || normalizedFormData.naoTemPai === null) {
        normalizedFormData.naoTemPai = false;
      }
      if (normalizedFormData.naoTemMae === undefined || normalizedFormData.naoTemMae === null) {
        normalizedFormData.naoTemMae = false;
      }
      
      // Garantir que campos de saúde sejam sempre strings válidas
      const healthFields = [
        'utilizaMedicacao', 'doencaCongenita', 'hipertensao', 'epilepsia', 'epilepsiaTratamento',
        'hemofilia', 'diabetes', 'diabetesTratamento', 'asma', 'asmaTratamento', 'alergia',
        'alergiaTratamento', 'problemaVisao', 'problemaAudicao', 'problemaFala', 'problemaLocomocao',
        'problemaAprendizagem', 'problemaComportamento', 'medicamentoControlado'
      ];
      healthFields.forEach(field => {
        if (!(field in normalizedFormData) || normalizedFormData[field] === null || normalizedFormData[field] === undefined) {
          normalizedFormData[field] = 'nao';
        } else {
          normalizedFormData[field] = ensureString(normalizedFormData[field]);
        }
      });
      
      // Verificar se há campos undefined e corrigir
      const undefinedFields = Object.keys(normalizedFormData).filter(key => normalizedFormData[key] === undefined);
      if (undefinedFields.length > 0) {
        undefinedFields.forEach(field => {
          normalizedFormData[field] = '';
        });
      }
      
      // Atualizar o formulário com todos os dados normalizados
      setFormDataRaw(normalizedFormData);

      // Verificar se há data de atualização nas observações
      const observacoes = updatedFormData.observacoes || "";
      logDebug("🔍 Verificando observações para data de atualização:");
      logDebug("👤 Aluno sendo processado:", data.Nome || "Nome não encontrado");
      logDebug("📋 Observações carregadas:", observacoes);
      
      const updateDate = detectUpdateDate(observacoes);
      logDebug("Data de atualização detectada:", updateDate);
      
      if (updateDate) {
        logDebug("🔍 Definindo alerta para aluno:", data.Nome || "Nome não encontrado");
        setLastUpdateDate(updateDate);
        setShowUpdateAlert(true);
        logDebug("📅 Dados atualizados detectados! Data:", updateDate);
        logDebug("✅ Alerta será exibido na interface");
        
        // GetAlunos3 já retorna InfoBloqueada; evita repetir a consulta do aluno.
        setGoogleDriveLink(scalar(data.InfoBloqueada));
      } else {
        logDebug("🔍 Nenhuma data encontrada - limpando alerta para aluno:", data.Nome || "Nome não encontrado");
        setShowUpdateAlert(false);
        setLastUpdateDate("");
        setGoogleDriveLink("");
        logDebug("❌ Nenhuma data de atualização encontrada nas observações");
        logDebug("✅ Estados do alerta limpos (sem dados atualizados)");
      }
      
      logDebug("=== RESUMO DO PREENCHIMENTO ===");
      logDebug("Formulário atualizado com:", updatedFormData);
      
      // Log específico das datas mapeadas
      logDebug("📅 RESUMO DAS DATAS MAPEADAS:");
      logDebug("Data nascimento do aluno:", updatedFormData.dataNascimento);
      logDebug("Data nascimento do pai:", updatedFormData.dataNascimentoPai);
      logDebug("Data nascimento da mãe:", updatedFormData.dataNascimentoMae);
    } else {
      logDebug("❌ Nenhum dado de aluno encontrado para preenchimento");
    }
  };

  // Função para remover acentos e caracteres especiais
  const removeAccents = (str) => {
    return str
      .normalize("NFD")
      .replace(/[\u0300-\u036f]/g, "")
      .replace(/[^a-zA-Z0-9\s\-()]/g, "")
      .trim();
  };

  // Função para detectar data de atualização nas observações
  const detectUpdateDate = (observacoes) => {
    logDebug("🔍 detectUpdateDate chamada com:", observacoes);
    
    // Garantir que observacoes é uma string
    const observacoesStr = typeof observacoes === 'string' 
      ? observacoes 
      : (Array.isArray(observacoes) ? observacoes[0] : String(observacoes || ''));
    
    if (!observacoesStr || observacoesStr.trim() === '') {
      logDebug("❌ Observações vazias ou nulas");
      return null;
    }
    
    // Procurar pelo padrão "ATUALIZADO EM: DD/MM/AAAA" ou "ATUALIZADO EM: DD-MM-AAAA"
    const updatePattern = /ATUALIZADO EM:\s*(\d{2}[/-]\d{2}[/-]\d{4})/i;
    logDebug("🔍 Aplicando regex:", updatePattern);
    
    const match = observacoesStr.match(updatePattern);
    logDebug("🔍 Resultado do match:", match);
    
    if (match) {
      logDebug("✅ Data encontrada:", match[1]);
      return match[1]; // Retorna apenas a data
    }
    
    logDebug("❌ Nenhuma data encontrada");
    return null;
  };

  // Resumo atual, preservando os itens históricos que deixaram de ser coletados.
  const generateCompleteSummary = () => {
    // Adicionar data de atualização no início (formato com traço para melhor compatibilidade)
    const dataAtualizacao = new Date().toLocaleDateString('pt-BR', {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric'
    }).replace(/\//g, '-'); // Converter barras em traços
    logDebug("📅 Data de atualização gerada:", dataAtualizacao);
    
    const healthAspects = [];

    // Lista de aspectos de saúde com seus textos descritivos (sem acentos)
    const healthQuestions = [
      {
        field: "utilizaMedicacao",
        text: "Utiliza medicacao",
        detailField: "medicacaoQual",
        detailPrefix: "Medicacao",
      },
      {
        field: "doencaCongenita",
        text: "Doenca congenita",
        detailField: "doencaCongenitaQual",
        detailPrefix: "Tipo",
      },
      {
        field: "hipertensao",
        text: "Hipertensao",
      },
      {
        field: "epilepsia",
        text: "Epilepsia",
        detailField: "epilepsiaTratamento",
        detailPrefix: "Tratamento",
      },
      {
        field: "hemofilia",
        text: "Hemofilia",
      },
      {
        field: "diabetes",
        text: "Diabetes",
        detailField: "diabetesTratamento",
        detailPrefix: "Tratamento",
      },
      {
        field: "asma",
        text: "Asma",
      },
      {
        field: "alergiaSubstancia",
        text: "Alergia a substancia",
        detailField: "alergiaSubstanciaQual",
        detailPrefix: "Substancia",
      },
      {
        field: "alergiaAlimentar",
        text: "Alergia alimentar",
        detailField: "alergiaAlimentarQual",
        detailPrefix: "Alimento",
      },
      {
        field: "planoSaude",
        text: "Possui plano de saude",
        detailField: "planoSaudeQual",
        detailPrefix: "Plano",
      },
      {
        field: "acompanhamentoEspecialista",
        text: "Acompanhamento com especialista",
        detailField: "acompanhamentoEspecialistaQual",
        detailPrefix: "Especialista",
      },
    ];

    // Verificar cada aspecto de saúde
    healthQuestions.forEach((question) => {
      if (formData[question.field] === "sim") {
        let aspectText = question.text;

        // Se tem campo de detalhamento e está preenchido, adicionar
        if (question.detailField && formData[question.detailField]?.trim()) {
          // Preservar pontuação, doses, barras e acentos informados na saúde.
          const cleanDetail = formData[question.detailField].trim();
          aspectText += ` (${question.detailPrefix} ${cleanDetail})`;
        }

        healthAspects.push(aspectText);
      }
    });

    // Criar array para todas as seções do resumo
    const summaryParts = [];

    // 1. ASPECTOS DE SAUDE
    if (healthAspects.length > 0) {
      summaryParts.push(
        `*** ASPECTOS DE SAUDE *** ${healthAspects.join(" * ")}`
      );
    }

    // Campos retirados da campanha não são recriados nem apagados da Sponte.
    const retired = readRetiredEnrollmentFields(formData.observacoes);
    if (retired.emergencyContacts) summaryParts.push(retired.emergencyContacts);
    if (retired.dueDate) summaryParts.push(retired.dueDate);
    if (retired.medicalTreatment) {
      summaryParts.push(`*** ASPECTO DE SAUDE HISTORICO *** ${retired.medicalTreatment}`);
    }

    // 2. AUTORIZACOES DE SAIDA
    if (formData.autorizaSaidaSozinho === "nao") {
      const authorizedPeople = pickupPeopleSummary(formData);
      summaryParts.push(`*** AUTORIZACOES *** NAO autorizado a sair sozinho${authorizedPeople ? ` * Pessoas autorizadas: ${authorizedPeople}` : ""}`);
    } else if (formData.autorizaSaidaSozinho === "sim") {
      summaryParts.push(
        `*** AUTORIZACOES *** AUTORIZADO a sair sozinho das dependencias da escola`
      );
    }

    if (formData.autorizaDireitoImagem === "sim") {
      summaryParts.push("*** DIREITO DE IMAGEM *** AUTORIZADO");
    } else if (formData.autorizaDireitoImagem === "nao") {
      summaryParts.push("*** DIREITO DE IMAGEM *** NAO AUTORIZADO");
    }

    if (formData.restricoesDireitoImagem?.trim()) {
      summaryParts.push(
        `*** RESTRICOES DIREITO DE IMAGEM *** ${removeAccents(formData.restricoesDireitoImagem.trim())}`
      );
    }

    if (paymentSummary(formData.formaPagamento)) {
      summaryParts.push(paymentSummary(formData.formaPagamento));
    }

    // 4. COR/RACA DO ALUNO
    if (formData.corRaca?.trim()) {
      const racaTexto = {
        branca: "Branca",
        preta: "Preta",
        parda: "Parda",
        amarela: "Amarela",
        indigena: "Indigena",
      };
      const corTexto =
        racaTexto[formData.corRaca.toLowerCase()] || formData.corRaca;
      summaryParts.push(`*** COR RACA *** ${corTexto}`);
    }

    // Juntar todas as partes com separadores de asterisco
    // Preservar os delimitadores reconhecidos pelos leitores de boleto/carnê e imagem.
    const summaryContent = summaryParts.join(" ");
    
    // Adicionar data de atualização no início do resumo
    const completeSummary = summaryContent 
      ? `ATUALIZADO EM: ${dataAtualizacao} ${summaryContent}`
      : `ATUALIZADO EM: ${dataAtualizacao}`;

    logDebug("📋 Resumo final gerado:", completeSummary);
    return completeSummary;
  };

  // Função de validação reutilizável
  const validateFormData = (showMessages = true) => {
    // Limpar erros anteriores
    const newFieldErrors = {};
    const missingFieldsMessages = [];
    
    // Validação básica dos campos obrigatórios
    const requiredFields = [
      { field: "nomeCompleto", label: "Nome Completo" },
      { field: "dataNascimento", label: "Data de Nascimento" },
      { field: "naturalidade", label: "Naturalidade" },
      { field: "nacionalidade", label: "Nacionalidade" },
      { field: "cpf", label: "CPF" },
      { field: "endereco", label: "Endereço" },
      { field: "bairro", label: "Bairro" },
      { field: "cidade", label: "Cidade" },
      { field: "cep", label: "CEP" },
      { field: "telefones", label: "Telefone(s)" },
      { field: "escolaAnterior", label: "Escola Anterior" },
      { field: "anoSerie", label: "Ano/Série" },
      { field: "nivel", label: "Nível" },
      { field: "turno", label: "Turno" },
      { field: "responsavelFinanceiro", label: "Responsável Financeiro" },
      { field: "responsavelPedagogico", label: "Responsável Pedagógico" },
      { field: "formaPagamento", label: "Forma de pagamento (boleto ou carnê)" },
      { field: "corRaca", label: "Cor/Raça do Aluno" },
      { field: "autorizaDireitoImagem", label: "Autorização de uso de imagem e voz" },
    ];

    const missingFields = requiredFields.filter(
      (item) => !formData[item.field]
    );
    missingFields.forEach((item) => {
      newFieldErrors[item.field] = true;
      missingFieldsMessages.push(item.label);
    });

    const nacionalidadeBrasileira = /^brasileir/i.test(formData.nacionalidade?.trim() || "");
    if (nacionalidadeBrasileira && formData.naturalidade && !parseNaturalidade(formData.naturalidade).uf) {
      newFieldErrors.naturalidade = true;
      if (!missingFieldsMessages.includes("Naturalidade (cidade e UF)")) {
        missingFieldsMessages.push("Naturalidade (cidade e UF)");
      }
    }

    // Validação para responsável financeiro
    if (
      formData.responsavelFinanceiro === "outro" &&
      !formData.nomeResponsavel?.trim()
    ) {
      newFieldErrors.nomeResponsavel = true;
      missingFieldsMessages.push("Nome do Responsável Financeiro");
    }

    const pickupErrors = validatePickup(formData);
    Object.assign(newFieldErrors, pickupErrors);
    missingFieldsMessages.push(...Object.values(pickupErrors));

    // Validação para campos obrigatórios dos pais (se não marcou "não tem pai/mãe")
    if (!formData.naoTemPai) {
      const paiRequiredFields = [
        { field: "nomePai", label: "Nome do Pai" },
        { field: "cpfPai", label: "CPF do Pai" },
        { field: "identidadePai", label: "RG do Pai" },
        { field: "dataNascimentoPai", label: "Data de Nascimento do Pai" },
        { field: "enderecoPai", label: "Endereço do Pai" },
        { field: "numeroEnderecoPai", label: "Número do Endereço do Pai" },
        { field: "cepPai", label: "CEP do Pai" },
        { field: "telefonePai", label: "Telefone do Pai" },
        { field: "bairroPai", label: "Bairro do Pai" },
      ];
      const paiMissingFields = paiRequiredFields.filter(
        (item) => !formData[item.field]
      );
      paiMissingFields.forEach((item) => {
        newFieldErrors[item.field] = true;
        missingFieldsMessages.push(item.label);
      });
    }

    if (!formData.naoTemMae) {
      const maeRequiredFields = [
        { field: "nomeMae", label: "Nome da Mãe" },
        { field: "cpfMae", label: "CPF da Mãe" },
        { field: "identidadeMae", label: "RG da Mãe" },
        { field: "dataNascimentoMae", label: "Data de Nascimento da Mãe" },
        { field: "enderecoMae", label: "Endereço da Mãe" },
        { field: "numeroEnderecoMae", label: "Número do Endereço da Mãe" },
        { field: "cepMae", label: "CEP da Mãe" },
        { field: "telefoneMae", label: "Telefone da Mãe" },
        { field: "bairroMae", label: "Bairro da Mãe" },
      ];
      const maeMissingFields = maeRequiredFields.filter(
        (item) => !formData[item.field]
      );
      maeMissingFields.forEach((item) => {
        newFieldErrors[item.field] = true;
        missingFieldsMessages.push(item.label);
      });
    }

    // Validação para campos de saúde que precisam de especificação quando "sim"
    const healthFields = [
      {
        condition: "utilizaMedicacao",
        field: "medicacaoQual",
        label: "Especificação da Medicação",
      },
      {
        condition: "doencaCongenita",
        field: "doencaCongenitaQual",
        label: "Especificação da Doença Congênita",
      },
      {
        condition: "epilepsia",
        field: "epilepsiaTratamento",
        label: "Tratamento para Epilepsia",
      },
      {
        condition: "diabetes",
        field: "diabetesTratamento",
        label: "Tratamento para Diabetes",
      },
      {
        condition: "alergiaSubstancia",
        field: "alergiaSubstanciaQual",
        label: "Especificação da Alergia à Substância",
      },
      {
        condition: "alergiaAlimentar",
        field: "alergiaAlimentarQual",
        label: "Especificação da Alergia Alimentar",
      },
      {
        condition: "planoSaude",
        field: "planoSaudeQual",
        label: "Especificação do Plano de Saúde",
      },
      {
        condition: "acompanhamentoEspecialista",
        field: "acompanhamentoEspecialistaQual",
        label: "Especificação do Acompanhamento",
      },
    ];

    healthFields.forEach((item) => {
      if (formData[item.condition] === "sim" && !formData[item.field]?.trim()) {
        newFieldErrors[item.field] = true;
        missingFieldsMessages.push(item.label);
      }
    });

    return {
      isValid: Object.keys(newFieldErrors).length === 0,
      fieldErrors: newFieldErrors,
      missingFields: missingFieldsMessages,
    };
  };

  const validateRequiredChoices = () => {
    const missingPayment = !PAYMENT_LABELS[formData.formaPagamento];
    const missingImageAuthorization = !formData.autorizaDireitoImagem;
    if (!missingPayment && !missingImageAuthorization) return true;
    setFieldErrors(previous => ({
      ...previous,
      ...(missingPayment ? { formaPagamento: true } : {}),
      ...(missingImageAuthorization ? { autorizaDireitoImagem: true } : {}),
    }));
    setTypeError("error");
    setErrorMessage(
      missingPayment && missingImageAuthorization
        ? "Selecione boleto ou carnê e informe a autorização de uso de imagem antes de continuar."
        : missingPayment
          ? "Selecione boleto ou carnê antes de continuar."
          : "Informe se autoriza ou não o uso de imagem antes de continuar."
    );
    setError(true);
    return false;
  };

  const buildEnrollmentContractStatus = () => ({
    schoolYear: ANO_MATRICULA,
    AlunoID: studentData?.AlunoID,
    studentName: formData.nomeCompleto || studentData?.Nome || studentData?.NomeAluno,
    classroomName: studentData?.Turma || studentData?.TurmaNome,
    gradeName: formData.anoSerie || studentData?.Serie || studentData?.SerieAluno || studentData?.AnoSerie,
    shiftName: formData.turno || studentData?.Turno || studentData?.TurnoAluno,
    paymentOption: formData.formaPagamento,
    contractSigned: Boolean(formData.contratoAssinado),
    imageAuthorization: formData.autorizaDireitoImagem,
    imageRestrictions: formData.restricoesDireitoImagem,
  });

  const persistEnrollmentContractStatus = async () => {
    if (!studentData?.AlunoID) return null;
    const status = buildEnrollmentContractStatus();
    const saved = await setEnrollmentContractStatus(studentData.AlunoID, {
      schoolYear: status.schoolYear,
      paymentOption: status.paymentOption,
      contractSigned: status.contractSigned,
      imageAuthorization: status.imageAuthorization,
      imageRestrictions: status.imageRestrictions,
      enrollmentSnapshot: status,
    });
    return requireConfirmedEnrollmentStatus(saved);
  };

  const tryPersistEnrollmentContractStatus = async () => {
    try {
      const response = await persistEnrollmentContractStatus();
      return { isSuccess: Boolean(response), message: "" };
    } catch (_) {
      return { isSuccess: false, message: "A gravação local de contrato, pagamento e imagem não foi confirmada. Você pode tentar salvar novamente." };
    }
  };

  const generatePDFWithStatus = async () => {
    const status = await tryPersistEnrollmentContractStatus();
    await generatePDFDocument(status.isSuccess ? "" : "PDF gerado. A gravação local de contrato, pagamento e imagem não foi confirmada. Você pode tentar salvar novamente.");
  };

  const handleSubmit = async () => {
    if (!validateRequiredChoices()) return;
    if (!selectedStudent || !studentData || studentLoading) {
      setTypeError("error");
      setErrorMessage("Por favor, selecione um aluno");
      setError(true);
      return;
    }
    
    setLoading(true);

    // Usar a nova função de validação
    const validation = validateFormData(false); // Não mostrar mensagens ainda

    if (!validation.isValid) {
      // Mostrar modal de confirmação com campos faltando
      setUpdateValidationResult(validation);
      setShowUpdateConfirmModal(true);
      setLoading(false);
      return;
    }
    
    // Gerar resumo completo para observações
    const completeSummary = generateCompleteSummary();
    logDebug("💾 Salvando dados do aluno:", studentData.Nome || "Nome não encontrado");
    logDebug("📝 Resumo completo gerado:", completeSummary);

    // Atualizar dados do aluno via API
    try {
      // Atualizar dados do aluno
      const studentResponse = await setUpdateStudents(studentData.AlunoID, formData, completeSummary);
      const studentValidation = validateSponteResponse(studentResponse, 'atualização do aluno');
      const contractStatusValidation = await tryPersistEnrollmentContractStatus();
      
      // Atualizar dados do pai (se houver ID)
      let fatherValidation = { isSuccess: true, userMessage: '' };
      if (formData.idPai) {
        const fatherResponse = await setUpdateFather(formData);
        fatherValidation = validateSponteResponse(fatherResponse, 'atualização do pai');
      }
      
      // Atualizar dados da mãe (se houver ID)
      let motherValidation = { isSuccess: true, userMessage: '' };
      if (formData.idMae) {
        const motherResponse = await setUpdateMother(formData);
        motherValidation = validateSponteResponse(motherResponse, 'atualização da mãe');
      }
      
      // Verificar se todas as operações foram bem-sucedidas
      const allSuccess = studentValidation.isSuccess && fatherValidation.isSuccess && motherValidation.isSuccess && contractStatusValidation.isSuccess;
      
      if (allSuccess) {
        setTypeError("success");
        setErrorMessage("Dados atualizados com sucesso!");
      } else if (studentValidation.isSuccess && fatherValidation.isSuccess && motherValidation.isSuccess) {
        setTypeError("warning");
        setErrorMessage(`Dados do aluno e dos responsáveis atualizados. ${contractStatusValidation.message}`);
      } else {
        setTypeError("error");
        let errorMessages = [];
        
        if (!studentValidation.isSuccess) {
          errorMessages.push(`Aluno: ${studentValidation.message}`);
        }
        if (!fatherValidation.isSuccess) {
          errorMessages.push(`Pai: ${fatherValidation.message}`);
        }
        if (!motherValidation.isSuccess) {
          errorMessages.push(`Mãe: ${motherValidation.message}`);
        }
        if (!contractStatusValidation.isSuccess) {
          errorMessages.push(`Contrato/imagem: ${contractStatusValidation.message}`);
        }
        
        setErrorMessage(`Erro na atualização:\n${errorMessages.join('\n')}\n\nVerifique os dados no Sponte.`);
      }
      
      setError(true);
      setLoading(false);
    } catch (error) {
      console.error("Erro ao atualizar dados:", error);
      setTypeError("error");
      setErrorMessage(error.code === "ENROLLMENT_STATUS_NOT_SAVED" ? "Os dados do aluno podem ter sido atualizados, mas a gravação local de contrato, pagamento e imagem não foi confirmada. Recarregue o aluno e tente novamente; se persistir, solicite suporte." : "Erro de conexão ao atualizar dados. Recarregue o aluno para conferir antes de tentar novamente.");
      setError(true);
      setLoading(false);
    }
  };

  // Função para executar a atualização após confirmação do modal
  const executeUpdate = async () => {
    if (!validateRequiredChoices()) return;
    if (/^brasileir/i.test(formData.nacionalidade?.trim() || "") && !parseNaturalidade(formData.naturalidade).uf) {
      setFieldErrors((previous) => ({ ...previous, naturalidade: true }));
      setTypeError("error");
      setErrorMessage("Selecione a cidade e a UF de nascimento antes de atualizar a Sponte.");
      setError(true);
      setShowUpdateConfirmModal(false);
      return;
    }
    setLoading(true);
    setShowUpdateConfirmModal(false);

    // Gerar resumo completo para observações
    const completeSummary = generateCompleteSummary();
    logDebug("💾 Salvando dados do aluno:", studentData.Nome || "Nome não encontrado");
    logDebug("📝 Resumo completo gerado:", completeSummary);

    // Atualizar dados do aluno via API
    try {
      // Atualizar dados do aluno
      const studentResponse = await setUpdateStudents(studentData.AlunoID, formData, completeSummary);
      const studentValidation = validateSponteResponse(studentResponse, 'atualização do aluno');
      const contractStatusValidation = await tryPersistEnrollmentContractStatus();
      
      // Atualizar dados do pai (se houver ID)
      let fatherValidation = { isSuccess: true, userMessage: '' };
      if (formData.idPai) {
        const fatherResponse = await setUpdateFather(formData);
        fatherValidation = validateSponteResponse(fatherResponse, 'atualização do pai');
      }
      
      // Atualizar dados da mãe (se houver ID)
      let motherValidation = { isSuccess: true, userMessage: '' };
      if (formData.idMae) {
        const motherResponse = await setUpdateMother(formData);
        motherValidation = validateSponteResponse(motherResponse, 'atualização da mãe');
      }
      
      // Verificar se todas as operações foram bem-sucedidas
      const allSuccess = studentValidation.isSuccess && fatherValidation.isSuccess && motherValidation.isSuccess && contractStatusValidation.isSuccess;
      
      if (allSuccess) {
        setTypeError("success");
        setErrorMessage("Dados atualizados com sucesso!");
      } else if (studentValidation.isSuccess && fatherValidation.isSuccess && motherValidation.isSuccess) {
        setTypeError("warning");
        setErrorMessage(`Dados do aluno e dos responsáveis atualizados. ${contractStatusValidation.message}`);
      } else {
        setTypeError("error");
        let errorMessages = [];
        
        if (!studentValidation.isSuccess) {
          errorMessages.push(`Aluno: ${studentValidation.message}`);
        }
        if (!fatherValidation.isSuccess) {
          errorMessages.push(`Pai: ${fatherValidation.message}`);
        }
        if (!motherValidation.isSuccess) {
          errorMessages.push(`Mãe: ${motherValidation.message}`);
        }
        if (!contractStatusValidation.isSuccess) {
          errorMessages.push(`Contrato/imagem: ${contractStatusValidation.message}`);
        }
        
        setErrorMessage(`Erro na atualização:\n${errorMessages.join('\n')}\n\nVerifique os dados no Sponte.`);
      }
      
      setError(true);
      setLoading(false);
    } catch (error) {
      console.error("Erro ao atualizar dados:", error);
      setTypeError("error");
      setErrorMessage(error.code === "ENROLLMENT_STATUS_NOT_SAVED" ? "Os dados do aluno podem ter sido atualizados, mas a gravação local de contrato, pagamento e imagem não foi confirmada. Recarregue o aluno e tente novamente; se persistir, solicite suporte." : "Erro de conexão ao atualizar dados. Recarregue o aluno para conferir antes de tentar novamente.");
      setError(true);
      setLoading(false);
    }
  };

  const handleGeneratePDF = async () => {
    if (!validateRequiredChoices()) return;
    // Validar dados antes de gerar PDF
    const validation = validateFormData();

    if (!validation.isValid) {
      // Mostrar modal de confirmação com campos faltando
      setPdfValidationResult(validation);
      setShowPdfConfirmModal(true);
      setFieldErrors(validation.fieldErrors);
      return;
    }

    // A falha do registro adicional não impede a geração do documento.
    await generatePDFWithStatus();
  };

  const prepareSignatureCanvas = () => {
    const canvas = signatureCanvasRef.current;
    if (!canvas) return;
    const rect = canvas.getBoundingClientRect();
    if (!rect.width || !rect.height) return;
    const dpr = Math.min(window.devicePixelRatio || 1, 3);
    signatureDprRef.current = dpr;
    canvas.width = Math.round(rect.width * dpr);
    canvas.height = Math.round(rect.height * dpr);
    const ctx = canvas.getContext("2d", { desynchronized: true, willReadFrequently: true });
    ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
    ctx.lineCap = "round";
    ctx.lineJoin = "round";
    ctx.strokeStyle = "#111827";
    ctx.imageSmoothingEnabled = false;
    signatureLastPointRef.current = null;
  };

  useEffect(() => {
    if (!showSignatureModal) return undefined;
    const frame = requestAnimationFrame(prepareSignatureCanvas);
    const handleResize = () => prepareSignatureCanvas();
    window.addEventListener("resize", handleResize);
    return () => {
      cancelAnimationFrame(frame);
      window.removeEventListener("resize", handleResize);
    };
  }, [showSignatureModal]);

  const getSignaturePoint = (event) => {
    const canvas = signatureCanvasRef.current;
    const rect = canvas.getBoundingClientRect();
    return {
      x: event.clientX - rect.left,
      y: event.clientY - rect.top,
      pressure: event.pressure && event.pressure > 0 ? event.pressure : 0.55,
    };
  };

	  const startSignature = (event) => {
	    event.preventDefault();
	    const canvas = signatureCanvasRef.current;
	    if (!canvas) return;
	    canvas.setPointerCapture?.(event.pointerId);
	    const ctx = canvas.getContext("2d", { desynchronized: true });
	    const point = getSignaturePoint(event);
	    signatureDrawingRef.current = true;
	    signatureLastPointRef.current = point;
	    ctx.beginPath();
	    ctx.fillStyle = "#111827";
      const radius = Math.max(0.75, Math.min(1.35, 0.65 + point.pressure * 0.55));
      ctx.arc(point.x, point.y, radius, 0, Math.PI * 2);
      ctx.fill();
	  };

  const drawSignatureSegment = (ctx, from, to) => {
    if (!from || !to) return;
    ctx.beginPath();
    ctx.moveTo(from.x, from.y);
    ctx.lineTo(to.x, to.y);
    ctx.lineWidth = Math.max(1.6, Math.min(2.6, 1.55 + to.pressure * 0.75));
    ctx.stroke();
  };

  const drawSignature = (event) => {
	    if (!signatureDrawingRef.current) return;
      if (signatureRawInputRef.current && event.type === "pointermove") return;
	    event.preventDefault();
	    const canvas = signatureCanvasRef.current;
	    if (!canvas) return;
	    const ctx = canvas.getContext("2d", { desynchronized: true });
	    const points = typeof event.getCoalescedEvents === "function" ? event.getCoalescedEvents() : [event];
	    points.forEach((pointerEvent) => {
	      const point = getSignaturePoint(pointerEvent);
	      const lastPoint = signatureLastPointRef.current || point;
      drawSignatureSegment(ctx, lastPoint, point);
	      signatureLastPointRef.current = point;
	    });
	  };

  const drawSignatureRaw = (event) => {
    drawSignature(event);
  };

  useEffect(() => {
    if (!showSignatureModal) return undefined;
    const canvas = signatureCanvasRef.current;
    signatureRawInputRef.current = Boolean(canvas && ("onpointerrawupdate" in canvas || "onpointerrawupdate" in window));
    if (!canvas || !signatureRawInputRef.current) return undefined;
    canvas.addEventListener("pointerrawupdate", drawSignatureRaw);
    return () => {
      signatureRawInputRef.current = false;
      canvas.removeEventListener("pointerrawupdate", drawSignatureRaw);
    };
  }, [showSignatureModal, drawSignatureRaw]);

	  const stopSignature = (event) => {
      event?.currentTarget?.releasePointerCapture?.(event.pointerId);
	    signatureDrawingRef.current = false;
	    signatureLastPointRef.current = null;
	  };

	  const clearSignatureCanvas = () => {
	    const canvas = signatureCanvasRef.current;
	    if (!canvas) return;
	    const ctx = canvas.getContext("2d", { willReadFrequently: true });
      ctx.save();
      ctx.setTransform(1, 0, 0, 1, 0, 0);
	    ctx.clearRect(0, 0, canvas.width, canvas.height);
      ctx.restore();
	    signatureLastPointRef.current = null;
	  };

	  const openSignatureModal = (type) => {
	    setActiveSignatureType(type);
	    setShowSignatureModal(true);
	    setTimeout(prepareSignatureCanvas, 0);
	  };

	  const cropSignatureCanvas = (canvas) => {
	    const ctx = canvas.getContext("2d", { willReadFrequently: true });
	    const { width, height } = canvas;
	    const pixels = ctx.getImageData(0, 0, width, height);
	    let minX = width;
	    let minY = height;
	    let maxX = 0;
	    let maxY = 0;
	    for (let y = 0; y < height; y += 1) {
	      for (let x = 0; x < width; x += 1) {
	        const index = (y * width + x) * 4;
	        if (pixels.data[index + 3] > 0) {
	          minX = Math.min(minX, x);
	          minY = Math.min(minY, y);
	          maxX = Math.max(maxX, x);
	          maxY = Math.max(maxY, y);
	        }
	      }
	    }
	    if (minX > maxX || minY > maxY) return "";
	    const padding = 8;
	    minX = Math.max(0, minX - padding);
	    minY = Math.max(0, minY - padding);
	    maxX = Math.min(width - 1, maxX + padding);
	    maxY = Math.min(height - 1, maxY + padding);
	    const cropped = document.createElement("canvas");
	    cropped.width = maxX - minX + 1;
	    cropped.height = maxY - minY + 1;
	    cropped.getContext("2d").drawImage(
	      canvas,
	      minX,
	      minY,
	      cropped.width,
	      cropped.height,
	      0,
	      0,
	      cropped.width,
	      cropped.height
	    );
	    return cropped.toDataURL("image/png");
	  };

	  const saveSignatureCanvas = () => {
	    const canvas = signatureCanvasRef.current;
	    if (!canvas) return;
	    const cropped = cropSignatureCanvas(canvas);
	    if (!cropped) return;
	    if (activeSignatureType === "pedagogical") {
	      setPedagogicalSignatureImageData(cropped);
	      setUseFinancialSignatureForPedagogical(false);
	    } else {
	      setFinancialSignatureImageData(cropped);
	    }
	    setShowSignatureModal(false);
	  };

	  const getEffectivePedagogicalSignature = () =>
	    useFinancialSignatureForPedagogical ? financialSignatureImageData : pedagogicalSignatureImageData;

  const addFittedSignatureToJsPdf = (doc, imageData, x, y, maxWidth, maxHeight) => {
    if (!imageData) return;
    const props = doc.getImageProperties(imageData);
    const ratio = props.width && props.height ? props.width / props.height : 4;
    let width = maxWidth;
    let height = width / ratio;
    if (height > maxHeight) {
      height = maxHeight;
      width = height * ratio;
    }
    const centeredX = x + (maxWidth - width) / 2;
    const centeredY = y + (maxHeight - height) / 2;
    doc.addImage(imageData, "PNG", centeredX, centeredY, width, height);
  };

  const readFileAsArrayBuffer = (file) =>
    new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onload = () => resolve(reader.result);
      reader.onerror = reject;
      reader.readAsArrayBuffer(file);
    });

  const loadPdfJs = async () => {
    const pdfjsLib = await import("pdfjs-dist");
    if (typeof window !== "undefined") {
      pdfjsLib.GlobalWorkerOptions.workerSrc = "/pdf.worker.min.mjs";
    }
    return pdfjsLib;
  };

  const appendContractPdf = async (requerimentoBytes) => {
    if (!contractPdfFile) return requerimentoBytes;

    const outputPdf = await PDFDocument.load(requerimentoBytes);
    const contractBuffer = await readFileAsArrayBuffer(contractPdfFile);
    const contractPdf = await PDFDocument.load(contractBuffer.slice(0));
    const pdfjsLib = await loadPdfJs();
    const markerPdf = await pdfjsLib.getDocument({ data: contractBuffer.slice(0) }).promise;

	    if (contractPdf.getPageCount() > 0) {
	      const pageIndex = contractPdf.getPageCount() - 1;
	      const targetPage = contractPdf.getPage(pageIndex);
	      const { width, height } = targetPage.getSize();
        const markerPage = await markerPdf.getPage(pageIndex + 1);
        const markerTextContent = await markerPage.getTextContent();
        const anchors = contractPipeAnchorsFromTextItems(markerTextContent.items || [], height);
        if (!anchors) {
          throw new Error("Não foi possível localizar os cinco marcadores do contrato importado.");
        }
	        const drawMark = (x, y) => {
	          targetPage.drawText("X", {
	            x,
	            y,
	            size: 9,
	          });
	        };
        if (formData.autorizaDireitoImagem === "sim") {
          drawMark(anchors.imageYes.x, anchors.imageYes.y);
        } else if (formData.autorizaDireitoImagem === "nao") {
          drawMark(anchors.imageNo.x, anchors.imageNo.y);
        }
        if (formData.restricoesDireitoImagem?.trim()) {
          targetPage.drawText(formData.restricoesDireitoImagem.trim(), {
            x: anchors.restrictions.x,
            y: anchors.restrictions.y,
            size: 8,
            maxWidth: width * 0.56,
            lineHeight: 9,
          });
        }
	      const drawContractSignature = async (imageData, xPosition, yPosition) => {
	        if (!imageData) return;
	        const signature = await contractPdf.embedPng(imageData);
          const ratio = signature.width && signature.height ? signature.width / signature.height : 4;
          const maxWidth = width * 0.28;
          const maxHeight = 20;
          let drawWidth = maxWidth;
          let drawHeight = drawWidth / ratio;
          if (drawHeight > maxHeight) {
            drawHeight = maxHeight;
            drawWidth = drawHeight * ratio;
          }
	        targetPage.drawImage(signature, {
	          x: width * xPosition,
	          y: height * yPosition,
	          width: drawWidth,
	          height: drawHeight,
	        });
	      };
	      await drawContractSignature(getEffectivePedagogicalSignature(), anchors.pedagogicalSignature.x / width, anchors.pedagogicalSignature.y / height);
	      await drawContractSignature(financialSignatureImageData, anchors.financialSignature.x / width, anchors.financialSignature.y / height);
	    }

    const copiedPages = await outputPdf.copyPages(contractPdf, contractPdf.getPageIndices());
    copiedPages.forEach((page) => outputPdf.addPage(page));
    return outputPdf.save();
  };

  const savePdfBytes = (bytes, fileName) => {
    const blob = new Blob([bytes], { type: "application/pdf" });
    const url = URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = url;
    link.download = fileName;
    document.body.appendChild(link);
    link.click();
    link.remove();
    URL.revokeObjectURL(url);
  };

  const generatePDFDocument = async (persistenceWarning = "") => {
    try {
      // Criar novo documento PDF com configurações otimizadas
      const doc = new jsPDF({
        compress: true, // Ativar compressão
        precision: 2,   // Reduzir precisão decimal para economizar espaço
        unit: 'mm',
        format: 'a4'
      });

      const response = await fetch(papelTimbrado);
      if (!response.ok) throw new Error("Não foi possível carregar o papel timbrado do requerimento.");
      const letterheadBytes = new Uint8Array(await response.arrayBuffer());
      const addMolduraToPage = async () => {
        doc.addImage(letterheadBytes, "PNG", 0, 0, 210, 297, "requerimento-campanha", "FAST");
      };

      // Adicionar moldura na primeira página
      await addMolduraToPage();

      // Função para verificar se precisa de nova página
      const checkNewPage = async (currentY, requiredSpace = 5) => {
        if (currentY + requiredSpace > 245) {
          // Reservar o rodapé ilustrado da nova campanha (a partir de ~250mm).
          doc.addPage();
          // Adicionar moldura na nova página
          await addMolduraToPage();
          return 20; // Aumentado de 12 para 20 para dar mais margem superior
        }
        return currentY;
      };

      // Cores padronizadas
      const LABEL_COLOR = [60, 60, 60]; // Cinza mais escuro para melhor contraste
      const VALUE_COLOR = [0, 0, 0]; // Preto para títulos principais
      const setLabel = () => {
        doc.setTextColor(...LABEL_COLOR);
        doc.setFont("helvetica", "bold");
        doc.setFontSize(6);
      };
      const setValue = () => {
        doc.setTextColor(...VALUE_COLOR);
        doc.setFont("helvetica", "bold");
        doc.setFontSize(7);
      };
      const setContentText = () => {
        doc.setTextColor(...VALUE_COLOR); // Usar preto para todos os textos de conteúdo
        doc.setFont("helvetica", "normal");
        doc.setFontSize(8);
      };
      const wrapText = (text, maxWidth = 170) =>
        doc.splitTextToSize(text, maxWidth);
      
      // Configurações iniciais
      doc.setFont("helvetica", "bold");
      doc.setFontSize(12);
      doc.setTextColor(0, 0, 0);

      // Cabeçalho com logo (ajustado para moldura - margem esquerda de 25mm)
      
      // Título principal
      doc.setFontSize(12);
      doc.text(TITULO_REQUERIMENTO, 105, 10, { align: "center" });

      // (Observação removida daqui e movida ao final do documento)
      doc.setFontSize(10);
      doc.setFont("helvetica", "normal");

      let y = 18;
      
      // ===== SEÇÃO 1: DADOS PESSOAIS DO ALUNO =====
      doc.setFont("helvetica", "bold");
      doc.setTextColor(...VALUE_COLOR);
      doc.setFontSize(9);
      // Ajustado para moldura - centralizando entre as margens (25mm esquerda + margem direita)
      doc.text("DADOS PESSOAIS DO ALUNO", 105, y, { align: "center" });

      y += 4;

      // Primeira linha - Nome e Data de Nascimento (ajustado para moldura)
      setLabel();
      doc.text("NOME COMPLETO DO ALUNO:", 20, y);
      doc.text("DATA DE NASCIMENTO:", 120, y);

      y += 4;
      setValue();
      doc.text(formData.nomeCompleto || "", 20, y);
      doc.text(formData.dataNascimento || "", 120, y);

      y += 4;

      // Segunda linha combinada - Naturalidade, CPF e RG na mesma linha
      setLabel();
      doc.text("NATURALIDADE:", 20, y);
      doc.text("CPF DO ALUNO:", 90, y);
      doc.text("RG DO ALUNO:", 150, y);

      y += 4;
      setValue();
      doc.text(formData.naturalidade || "", 20, y);
      doc.text(formData.cpf || "", 90, y);
      doc.text(formData.rg || formData.identidade || "", 150, y);

      y += 4;

      // Endereço e Número
      setLabel();
      doc.text("ENDEREÇO:", 20, y);
      doc.text("NÚMERO:", 120, y);

      y += 4;
      setValue();
      doc.text(formData.endereco || "", 20, y);
      doc.text(formData.numeroEndereco || "", 120, y);

      y += 4;

      // Bairro, Cidade e CEP
      setLabel();
      doc.text("BAIRRO:", 20, y);
      doc.text("CIDADE:", 80, y);
      doc.text("CEP:", 140, y);

      y += 4;
      setValue();
      doc.text(formData.bairro || "", 20, y);
      doc.text(formData.cidade || "", 80, y);
      doc.text(formData.cep || "", 140, y);

      y += 4;

      // Telefone, Email e Escola anterior na mesma linha
      setLabel();
      doc.text("TELEFONE (S):", 20, y);
      doc.text("E-MAIL (RESPONSÁVEL):", 80, y);
      doc.text("ESCOLA ANTERIOR:", 150, y);

      y += 4;
      setValue();
      doc.text(formData.telefones || "", 20, y);
      doc.text(formData.emailResponsavel || "", 80, y);
      doc.text(formData.escolaAnterior || "", 150, y);

      y += 4;

      // Ano/Série, Nível e Turno na mesma linha
      setLabel();
      doc.text("ANO/SÉRIE QUE PRETENDE CURSAR:", 20, y);
      doc.text("NÍVEL:", 90, y);
      doc.text("TURNO:", 150, y);

      y += 4;
      setValue();
      doc.text(formData.anoSerie || "", 20, y);
      doc.text(formData.nivel || "", 90, y);
      doc.text(formData.turno || "", 150, y);

      y += 4;

      // ===== SEÇÃO 2: FILIAÇÃO (DADOS DOS PAIS) =====
      y = await checkNewPage(y, 92);
      doc.setFont("helvetica", "bold");
      doc.setTextColor(...VALUE_COLOR);
      doc.setFontSize(9);
      y += 4;
      doc.text("FILIAÇÃO (DADOS DOS PAIS)", 105, y, { align: "center" });
      y += 4;

      // Dados do Pai
      setLabel();
      doc.text("NOME DO PAI:", 20, y);

      y += 4;
      setValue();
      doc.text(formData.nomePai || "", 20, y);

      y += 4;

      // CPF, Identidade e Data de Nascimento do Pai
      setLabel();
      doc.text("CPF:", 20, y);
      doc.text("CARTEIRA DE IDENTIDADE:", 80, y);
      doc.text("DATA DE NASCIMENTO:", 140, y);

      y += 4;
      setValue();
      doc.text(formData.cpfPai || "", 20, y);
      doc.text(formData.identidadePai || "", 80, y);
      doc.text(formData.dataNascimentoPai || "", 140, y);

      y += 4;

      // Endereço do Pai
      setLabel();
      doc.text("ENDEREÇO:", 20, y);
      doc.text("NÚMERO:", 80, y);
      doc.text("COMPLEMENTO:", 140, y);

      y += 4;
      setValue();
      doc.text(formData.enderecoPai || "", 20, y);
      doc.text(formData.numeroEnderecoPai || "", 80, y);
      doc.text(formData.complementoPai || "", 140, y);

      y += 4;

      // Bairro, CEP e Telefone do Pai
      setLabel();
      doc.text("BAIRRO:", 20, y);
      doc.text("CEP:", 80, y);
      doc.text("TELEFONE / WHATSAPP:", 140, y);

      y += 4;
      setValue();
      doc.text(formData.bairroPai || "", 20, y);
      doc.text(formData.cepPai || "", 80, y);
      doc.text(formData.telefonePai || "", 140, y);

      y += 4;

      // Email do Pai
      setLabel();
      doc.text("E-MAIL:", 20, y);

      y += 4;
      setValue();
      doc.text(formData.emailPai || "", 20, y);

      y += 4;

      // Dados da Mãe
      setLabel();
      doc.text("NOME DA MÃE:", 20, y);

      y += 4;
      setValue();
      doc.text(formData.nomeMae || "", 20, y);

      y += 4;

      // CPF, Identidade e Data de Nascimento da Mãe
      setLabel();
      doc.text("CPF:", 20, y);
      doc.text("CARTEIRA DE IDENTIDADE:", 80, y);
      doc.text("DATA DE NASCIMENTO:", 140, y);

      y += 4;
      setValue();
      doc.text(formData.cpfMae || "", 20, y);
      doc.text(formData.identidadeMae || "", 80, y);
      doc.text(formData.dataNascimentoMae || "", 140, y);

      y += 4;

      // Endereço da Mãe
      setLabel();
      doc.text("ENDEREÇO:", 20, y);
      doc.text("NÚMERO:", 80, y);
      doc.text("COMPLEMENTO:", 140, y);

      y += 4;
      setValue();
      doc.text(formData.enderecoMae || "", 20, y);
      doc.text(formData.numeroEnderecoMae || "", 80, y);
      doc.text(formData.complementoMae || "", 140, y);

      y += 4;

      // Bairro, CEP e Telefone da Mãe
      setLabel();
      doc.text("BAIRRO:", 20, y);
      doc.text("CEP:", 80, y);
      doc.text("TELEFONE / WHATSAPP:", 140, y);

      y += 4;
      setValue();
      doc.text(formData.bairroMae || "", 20, y);
      doc.text(formData.cepMae || "", 80, y);
      doc.text(formData.telefoneMae || "", 140, y);

      y += 4;

      // Email da Mãe
      setLabel();
      doc.text("E-MAIL:", 20, y);

      y += 4;
      setValue();
      doc.text(formData.emailMae || "", 20, y);

      y += 4;

      // ===== SEÇÃO 3: RESPONSÁVEL FINANCEIRO =====
      y = await checkNewPage(y, formData.responsavelFinanceiro === "outro" ? 56 : 18);
      doc.setFont("helvetica", "bold");
      doc.setTextColor(...VALUE_COLOR);
      doc.setFontSize(9);
      y += 4;
      doc.text("RESPONSÁVEL FINANCEIRO", 105, y, { align: "center" });

      y += 4;
      y += 4; // Pular uma linha

      // Quem é o responsável financeiro
      setValue();
      const rf = String(formData.responsavelFinanceiro || "");
      const paiX = rf === "pai" ? "x" : " ";
      const maeX = rf === "mae" ? "x" : " ";
      const outroX = rf === "outro" ? "x" : " ";
      doc.text(`PAI: (${paiX})  MÃE: (${maeX})  OUTRO: (${outroX})`, 105, y, {
        align: "center",
      });

      // Dados do responsável financeiro (se for outro)
      if (formData.responsavelFinanceiro === "outro") {
        // Nome do Responsável
        setLabel();
        doc.text("NOME:", 20, y);

        y += 4;
        setValue();
        doc.text(formData.nomeResponsavel || "", 20, y);

        y += 4;

        // CPF, Identidade e Data de Nascimento
        setLabel();
        doc.text("CPF:", 20, y);
        doc.text("CARTEIRA DE IDENTIDADE:", 80, y);
        doc.text("DATA DE NASCIMENTO:", 140, y);

        y += 4;
        setValue();
        doc.text(formData.cpfResponsavel || "", 20, y);
        doc.text(formData.identidadeResponsavel || "", 80, y);
        doc.text(formData.dataNascimentoResponsavel || "", 140, y);

        y += 4;

        // Endereço e Complemento
        setLabel();
        doc.text("ENDEREÇO:", 20, y);
        doc.text("COMPLEMENTO:", 110, y);

        y += 4;
        setValue();
        doc.text(formData.enderecoResponsavel || "", 20, y);
        doc.text(formData.complementoResponsavel || "", 110, y);

        y += 4;

        // Bairro, CEP e Telefone
        setLabel();
        doc.text("BAIRRO:", 20, y);
        doc.text("CEP:", 80, y);
        doc.text("TELEFONE / WHATSAPP:", 140, y);

        y += 4;
        setValue();
        doc.text(formData.bairroResponsavel || "", 20, y);
        doc.text(formData.cepResponsavel || "", 80, y);
        doc.text(formData.telefoneResponsavel || "", 140, y);

        y += 4;

        // Email
        setLabel();
        doc.text("E-MAIL:", 20, y);

        y += 4;
        setValue();
        doc.text(
          formData.emailResponsavelFinanceiro ||
            formData.emailResponsavel ||
            "",
          20,
          y
        );

        y += 4;
      }

      // ===== SEÇÃO 4: RESPONSÁVEL PEDAGÓGICO =====
      y = await checkNewPage(y, 18);
      doc.setFont("helvetica", "bold");
      doc.setTextColor(...VALUE_COLOR);
      doc.setFontSize(9);
      y += 4;
      doc.text("RESPONSÁVEL PEDAGÓGICO", 105, y, { align: "center" });

      y += 4;
      y += 4; // Pular uma linha

      // Quem é o responsável pedagógico
      setValue();
      const rp = String(formData.responsavelPedagogico || "");
      const paiXPed = rp === "pai" ? "x" : " ";
      const maeXPed = rp === "mae" ? "x" : " ";
      doc.text(`PAI: (${paiXPed})  MÃE: (${maeXPed})`, 105, y, {
        align: "center",
      });

      y += 4;

      // ===== SEÇÃO 5: FORMA DE PAGAMENTO =====
      y = await checkNewPage(y, 8);
      setValue();
      doc.text(`FORMA DE PAGAMENTO: ${PAYMENT_LABELS[formData.formaPagamento] || "Não informado"}`, 105, y + 4, { align: "center" });
      y += 8;

      // ===== SEÇÃO 6: COR/RAÇA DO ALUNO =====
      y = await checkNewPage(y, 38);
      doc.setFont("helvetica", "bold");
      doc.setFontSize(9);
      y += 4;
      doc.text("COR/RAÇA DO ALUNO PARA O CENSO ESCOLAR", 105, y, {
        align: "center",
      });

      y += 4;
      y += 4; // Pular uma linha

      doc.setFont("helvetica", "normal");
      doc.setFontSize(7);
      const linhaCor1 = wrapText(
        "Conforme solicitação do Ministério da Educação, através da Portaria INPE 156 de 20/10/2004, indique a cor/raça do aluno para o censo escolar:",
        170
      );
      doc.text(linhaCor1, 105, y, { align: "center" });

      y += 4;
      y += 4; // Pular uma linha

      const cor = (c) =>
        (formData.corRaca || "").toLowerCase() === c.toLowerCase();
      setValue();
      doc.text(
        `(${cor("Branca") ? "x" : " "}) BRANCA  (${
          cor("Preta") ? "x" : " "
        }) PRETA  (${cor("Parda") ? "x" : " "}) PARDA  (${
          cor("Amarela") ? "x" : " "
        }) AMARELA  (${cor("Indígena") ? "x" : " "}) INDÍGENA  (${
          cor("Não declarada") ? "x" : " "
        }) NÃO DECLARADA`,
        105,
        y,
        { align: "center" }
      );

      y += 4;

      // ===== SEÇÃO 7: ASPECTOS DE SAÚDE =====
      // Aproveitar uma página recém-aberta sem criar uma folha quase vazia.
      y = await checkNewPage(y, 100);
      doc.setFont("helvetica", "bold");
      doc.setTextColor(...VALUE_COLOR);
      doc.setFontSize(9);
      y += 4;
      doc.text("ASPECTOS DE SAÚDE", 105, y, { align: "center" });

      y += 4;

      // Adicionar data de atualização
      const dataAtualizacao = new Date().toLocaleDateString('pt-BR', {
        day: '2-digit',
        month: '2-digit',
        year: 'numeric'
      });
      
      doc.setFont("helvetica", "normal");
      doc.setFontSize(7);
      doc.setTextColor(100, 100, 100); // Cor cinza para destacar que é informação de sistema
      doc.text(`Atualizado em: ${dataAtualizacao}`, 105, y, { align: "center" });
      
      y += 6; // Espaço adicional após a data

      // B) O ALUNO APRESENTA (DUAS COLUNAS)
      const leftX = 20;
      const rightX = 110;
      let rowY = y;
      const rowH = 3;

      // Título
      doc.setFont("helvetica", "bold");
      doc.setTextColor(...VALUE_COLOR);

      rowY += 6;

      const opt = (cond) =>
        `(${cond ? "x" : " "}) SIM  (${cond ? " " : "x"}) NÃO`;

      // 1 esquerda / 6 direita
      setLabel();
      doc.text("1. DOENÇA CONGÊNITA:", leftX, rowY);
      const cong = formData.doencaCongenita === "sim";
      doc.text(opt(cong), leftX + 55, rowY);
      if (cong && formData.doencaCongenitaQual?.trim()) {
        rowY += 3;
        setValue();
        doc.text(formData.doencaCongenitaQual.trim(), leftX, rowY);
        setLabel();
        rowY += 3;
      }
      doc.text("6. ASMA:", rightX, rowY);
      const asma = formData.asma === "sim";
      doc.text(opt(asma), rightX + 60, rowY);
      if (asma) {
        rowY += 3;
        setValue();
        doc.text(formData.asmaQual || "", rightX, rowY);
        setLabel();
        rowY += 3;
      }
      rowY += rowH;

      // 2 esquerda / 7 direita
      doc.text("2. HIPERTENSÃO:", leftX, rowY);
      const hiper = formData.hipertensao === "sim";
      doc.text(opt(hiper), leftX + 55, rowY);
      doc.text("7. ALERGIA A SUBSTÂNCIA:", rightX, rowY);
      const alergSub = formData.alergiaSubstancia === "sim";
      doc.text(opt(alergSub), rightX + 60, rowY);
      if (alergSub && formData.alergiaSubstanciaQual?.trim()) {
        rowY += 3;
        setValue();
        doc.text(formData.alergiaSubstanciaQual.trim(), rightX, rowY);
        setLabel();
        rowY += 3;
      }
      rowY += rowH;

      // 3 esquerda / 8 direita
      doc.text("3. EPILEPSIA:", leftX, rowY);
      const epi = formData.epilepsia === "sim";
      doc.text(opt(epi), leftX + 55, rowY);
      if (epi) {
        rowY += 3;
        const epiTrat = formData.epilepsiaTratamento === "sim";
        doc.text(
          `tratamento: (${epiTrat ? "x" : " "}) SIM  (${
            epiTrat ? " " : "x"
          }) NÃO`,
          leftX,
          rowY
        );
        rowY += 3;
      }
      doc.text("8. ALERGIA ALIMENTAR:", rightX, rowY);
      const alergAli = formData.alergiaAlimentar === "sim";
      doc.text(opt(alergAli), rightX + 60, rowY);
      if (alergAli && formData.alergiaAlimentarQual?.trim()) {
        rowY += 3;
        setValue();
        doc.text(formData.alergiaAlimentarQual.trim(), rightX, rowY);
        setLabel();
        rowY += 3;
      }
      rowY += rowH;

      // 4 esquerda / 9 direita
      doc.text("4. HEMOFILIA:", leftX, rowY);
      const hemo = formData.hemofilia === "sim";
      doc.text(opt(hemo), leftX + 55, rowY);
      rowY += rowH;

      // 5 esquerda / 10 direita (Medicação)
      doc.text("5. DIABETES:", leftX, rowY);
      const diab = formData.diabetes === "sim";
      doc.text(opt(diab), leftX + 55, rowY);
      if (diab) {
        rowY += 3;
        const diabTrat = formData.diabetesTratamento === "sim";
        doc.text(
          `tratamento: (${diabTrat ? "x" : " "}) SIM  (${
            diabTrat ? " " : "x"
          }) NÃO`,
          leftX,
          rowY
        );
        rowY += 3;
      }
      doc.text("9. UTILIZA MEDICAÇÃO:", rightX, rowY);
      const utilizaMed = formData.utilizaMedicacao === "sim";
      doc.text(
        `(${utilizaMed ? "x" : " "}) SIM  (${utilizaMed ? " " : "x"}) NÃO`,
        rightX + 60,
        rowY
      );
      if (utilizaMed && formData.medicacaoQual?.trim()) {
        rowY += 3;
        setValue();
        doc.text(formData.medicacaoQual.trim(), rightX, rowY);
        setLabel();
        rowY += 3;
      }

      y = rowY + 6;

      // C) Plano de Saúde
      setLabel();
      doc.text("C) O EDUCANDO POSSUI ALGUM PLANO DE SAÚDE?", 20, y);
      const plano = formData.planoSaude === "sim";
      doc.text(
        `(${plano ? " " : "x"}) NÃO  (${plano ? "x" : " "}) SIM ${
          plano ? "QUAL?" : ""
        }`,
        110,
        y
      );

      y += 4;
      setValue();
      if (plano && formData.planoSaudeQual?.trim()) {
        doc.text(formData.planoSaudeQual.trim(), 110, y);
      }

      y += 4;

      // D) Acompanhamento Especialista
      setLabel();
      doc.text("D) FAZ ALGUM ACOMPANHAMENTO COM ESPECIALISTA:", 20, y);
      const espec = formData.acompanhamentoEspecialista === "sim";
      doc.text(
        `(${espec ? " " : "x"}) NÃO  (${espec ? "x" : " "}) SIM ${
          espec ? "QUAL?" : ""
        }`,
        110,
        y
      );

      y += 4;
      setValue();
      if (espec && formData.acompanhamentoEspecialistaQual?.trim()) {
        doc.text(formData.acompanhamentoEspecialistaQual.trim(), 110, y);
      }

      y += 4;

      // ===== SEÇÃO 8: AUTORIZAÇÕES =====
      y = await checkNewPage(y, 40);
      doc.setFont("helvetica", "bold");
      doc.setTextColor(...VALUE_COLOR);
      doc.setFontSize(10);
      y += 4;
      doc.text("AUTORIZAÇÕES", 105, y, { align: "center" });
      y += 4;
      y += 4;

      // Autorização para sair sozinho
      setContentText();
      const textoAut1 = wrapText(
        "Autorizo meu (minha) filho (filha) a sair das dependências da escola, após conclusão das aulas, podendo ir para casa em cada turno diário sem a condução dos pais e/ou responsáveis:",
        170
      );
      doc.text(textoAut1, 20, y);
      y += textoAut1.length * 4;

      // Marca SIM/NÃO - Centralizado
      const saidaSozinho = formData.autorizaSaidaSozinho === "sim";
      doc.text(
        `(${saidaSozinho ? "x" : " "}) SIM   (${saidaSozinho ? " " : "x"}) NÃO`,
        105,
        y,
        { align: "center" }
      );

      y += 6;

      // Se não autoriza, preencher acompanhantes
      if (formData.autorizaSaidaSozinho === "nao") {
        setContentText();
        const linhaAcomp = wrapText(
          "Só tem permissão para sair da escola acompanhado(a) por:",
          170
        );
        doc.text(linhaAcomp, 20, y);

        y += 6;

        const acompanhantes = getAuthorizedPickupPeople(formData);
        for (const [index, acompanhante] of acompanhantes.entries()) {
          setContentText();
          const lines = wrapText(`${index + 1}. ${acompanhante.name || "Nome não informado"} - ${acompanhante.relationship || "Vínculo não informado"} - Tel.: ${acompanhante.phone || "Não informado"}`, 170);
          for (const line of lines) {
            y = await checkNewPage(y, 4);
            setContentText();
            doc.text(line, 20, y);
            y += 4;
          }
          y += 2;
        }
      }

      y += 4;

      y = await checkNewPage(y, 34);
      doc.setFont("helvetica", "bold");
      doc.setTextColor(...VALUE_COLOR);
      doc.setFontSize(9);
      y += 4;
      doc.text("DIREITO DE IMAGEM E VOZ", 105, y, { align: "center" });
      y += 6;
      setContentText();
      const textoImagem = wrapText(
        "Autorização facultativa para uso de imagem/voz em canais institucionais públicos da escola para divulgação de atividades educacionais, culturais e esportivas:",
        170
      );
      doc.text(textoImagem, 20, y);
      y += textoImagem.length * 4;
      const imagemAutorizada = formData.autorizaDireitoImagem === "sim";
      doc.text(
        `(${imagemAutorizada ? "x" : " "}) AUTORIZO   (${imagemAutorizada ? " " : "x"}) NÃO AUTORIZO`,
        105,
        y,
        { align: "center" }
      );
      y += 6;
      if (formData.restricoesDireitoImagem?.trim()) {
        setLabel();
        doc.text("PREFERÊNCIAS/RESTRIÇÕES ESPECÍFICAS:", 20, y);
        y += 4;
        setContentText();
        const restricoesImagem = wrapText(formData.restricoesDireitoImagem.trim(), 170);
        for (const line of restricoesImagem) {
          y = await checkNewPage(y, 4);
          setContentText();
          doc.text(line, 20, y);
          y += 4;
        }
      }

      // ===== SEÇÃO 9: DECLARAÇÕES =====
      // Reservar também a observação e a assinatura, evitando assinatura isolada.
      y = await checkNewPage(y, 90);
      doc.setFont("helvetica", "bold");
      doc.setTextColor(...VALUE_COLOR);
      doc.setFontSize(10);
      y += 4;
      doc.text("Estamos cientes de que:", 20, y);
      y += 4;

      y += 4;

      setContentText();
      const d1 = wrapText(
        "- A presente proposta deve ser analisada pelos departamentos pedagógico e financeiro, e pode ser ou não deferida, nos termos das leis 9.394, de 20/12/1996 e 8.070, de 23/11/1990.",
        170
      );
      const d2 = wrapText(
        "- A matrícula somente será formalizada com a assinatura dos responsáveis pelo aluno e pela instituição de ensino no Contrato de Prestação de Serviços Educacionais, para o ano letivo requerido.",
        170
      );
      const d3 = wrapText(
        "- As matrículas estão condicionadas ao preenchimento de vagas por turno e turma.",
        170
      );
      const d4 = wrapText(
        "- A presente reserva de vaga não representa, nem o contrato de prestação de serviços educacionais, nem a efetivação da matrícula.",
        170
      );
      const d5 = wrapText(
        "- As informações contidas nesta ficha são de inteira responsabilidade dos pais e/ou responsáveis.",
        170
      );
      for (const blk of [d1, d2, d3, d4, d5]) {
        y = await checkNewPage(y, blk.length * 3.6 + 2);
        setContentText();
        doc.text(blk, 20, y);
        y += blk.length * 3.6;
      }

      const obs = wrapText(
        "Obs.: Quaisquer alterações ocorridas nos dados contidos nesta ficha deverão ser imediatamente comunicadas à Secretaria.",
        170
      );
      y = await checkNewPage(y, obs.length * 4 + 4);
      setContentText();
      y += 4;
      doc.text(obs, 20, y);

      y += 4;

      y = await checkNewPage(y, 24);
      // Data e Assinatura em duas colunas
      doc.setFont("helvetica", "bold");
      doc.setFontSize(9);
      y += 8;

      // Coluna esquerda: Data da devolução
      doc.text("Data da devolução deste ____/____/____", 20, y);

	      // Coluna direita: Linha de assinatura primeiro
	      doc.text("_________________________________", 140, y);
	      if (financialSignatureImageData) {
	        addFittedSignatureToJsPdf(doc, financialSignatureImageData, 145, y - 8.5, 50, 8);
	      }

      y += 4;

      // Texto "Nestes termos" na esquerda
      doc.text("Nestes termos, pede deferimento.", 20, y);

      // Texto "RESPONSÁVEL" centralizado abaixo da linha (coluna direita)
      doc.text("RESPONSÁVEL", 170, y, { align: "center" });

      y += 12;

      // Logo no rodapé (removido pois agora faz parte da moldura)
      doc.setFontSize(12);
      y += 8;
      // Slogan removido - agora está na moldura
      
	      const nomeArquivo = `requerimento-${formData.nomeCompleto
	        .replace(/\s+/g, "-")
	        .toLowerCase()}-${new Date().toISOString().split("T")[0]}.pdf`;
	      const requerimentoBytes = doc.output("arraybuffer");
	      const finalBytes = await appendContractPdf(requerimentoBytes);
	      savePdfBytes(finalBytes, nomeArquivo);
      
      // Mostrar mensagem de sucesso
      setTypeError(persistenceWarning ? "warning" : "success");
      setErrorMessage(persistenceWarning || "PDF gerado com sucesso!");
      setError(true);
    } catch (error) {
      console.error("Erro ao gerar PDF:", error);
      setTypeError("error");
      setErrorMessage("Erro ao gerar PDF. Tente novamente.");
      setError(true);
    }
  };

  const handleClose = (event, reason) => {
    if (reason === "clickaway") return;
    setError(false);
  };

  const filteredStudents = useMemo(
    () => filterEnrollmentStudents(students, searchValue),
    [students, searchValue]
  );

  const handleStudentSelect = (_, newValue) => {
    setSelectedStudent(newValue);
  };

  const clearForm = () => {
    clearTimeout(advanceTimeoutRef.current);
    setSectionOpenRequest({ id: "", token: 0 });
    setFieldErrors({});
    setFormSession(previous => previous + 1);
    setFinancialSignatureImageData("");
    setPedagogicalSignatureImageData("");
    setContractPdfFile(null);
    setUseFinancialSignatureForPedagogical(true);
    setFormDataRaw({
      nomeCompleto: "",
      dataNascimento: "",
      naturalidade: "",
      nacionalidade: "Brasileiro(a)",
      estado: "",
      cpf: "",
      rg: "",
      endereco: "",
      numeroEndereco: "",
      bairro: "",
      cidade: "",
      cep: "",
      complemento: "",
      telefones: "",
      emailResponsavel: "",
      escolaAnterior: "",
      anoSerie: "",
      nivel: "",
      turno: "",
      naoTemPai: false,
      idPai: "",
      nomePai: "",
      cpfPai: "",
      identidadePai: "",
      orgaoEmissorPai: "",
      dataNascimentoPai: "",

      estadoPai: "",
      enderecoPai: "",
      numeroEnderecoPai: "",
      complementoPai: "",
      cepPai: "",
      telefonePai: "",
      bairroPai: "",
      emailPai: "",
      profissaoPai: "",
      naoTemMae: false,
      idMae: "",
      nomeMae: "",
      cpfMae: "",
      identidadeMae: "",
      orgaoEmissorMae: "",
      dataNascimentoMae: "",

      estadoMae: "",
      enderecoMae: "",
      numeroEnderecoMae: "",
      complementoMae: "",
      cepMae: "",
      telefoneMae: "",
      bairroMae: "",
      emailMae: "",
      profissaoMae: "",
      responsavelFinanceiro: "",
      responsavelPedagogico: "",
      nomeResponsavel: "",
      cpfResponsavel: "",
      identidadeResponsavel: "",
      orgaoEmissorResponsavel: "",
      dataNascimentoResponsavel: "",

      estadoResponsavel: "",
      enderecoResponsavel: "",
      complementoResponsavel: "",
      cepResponsavel: "",
      telefoneResponsavel: "",
      bairroResponsavel: "",
      emailResponsavelFinanceiro: "",
      profissaoResponsavel: "",
      formaPagamento: "",
      contratoAssinado: false,
      corRaca: "",
      utilizaMedicacao: "nao",
      medicacaoQual: "",
      doencaCongenita: "nao",
      doencaCongenitaQual: "",
      hipertensao: "nao",
      epilepsia: "nao",
      epilepsiaTratamento: "nao",
      hemofilia: "nao",
      diabetes: "nao",
      diabetesTratamento: "nao",
      asma: "nao",
      alergiaSubstancia: "nao",
      alergiaSubstanciaQual: "",
      alergiaAlimentar: "nao",
      alergiaAlimentarQual: "",
      planoSaude: "nao",
      planoSaudeQual: "",
      acompanhamentoEspecialista: "nao",
      acompanhamentoEspecialistaQual: "",
      ...EMPTY_PICKUP,
    autorizaSaidaSozinho: "nao",
      autorizaDireitoImagem: "",
      restricoesDireitoImagem: "",
      saidaAcompanhada: "nao",
      saidaAcompanhadaParentesco1: "",
      saidaAcompanhadaTelefone1: "",
      saidaAcompanhadaParentesco2: "",
      saidaAcompanhadaTelefone2: "",
      saidaAcompanhadaParentesco3: "",
      saidaAcompanhadaTelefone3: "",
      dataDevolucao: "",
      responsavelAssinatura: "",
    });
  };

  const currentValidation = validateFormData(false);
  validationRef.current = currentValidation;
  const advanceToNextRequired = sectionId => {
    const targetId = nextRequiredSection(sectionId, validationRef.current.fieldErrors);
    if (!targetId) return;
    clearTimeout(advanceTimeoutRef.current);
    setSectionOpenRequest(previous => ({ id: targetId, token: previous.token + 1 }));
    advanceTimeoutRef.current = setTimeout(() => {
      if (document.querySelector('[role="dialog"]')) return;
      const errors = validationRef.current.fieldErrors;
      if (Object.keys(errors).some(field => sectionForRequirementField(field) === sectionId)) return;
      const root = document.getElementById(`requerimento-${targetId}`);
      const field = Object.keys(errors).find(key => sectionForRequirementField(key) === targetId);
      if (!root || !field) return;
      const aliases = { retiradaPai: formData.nomePai ? 'telefonePai' : 'nomePai', retiradaMae: formData.nomeMae ? 'telefoneMae' : 'nomeMae' };
      const direct = document.getElementById(`requerimento-campo-${aliases[field] || field}`);
      const target = direct?.matches('input, textarea, select, [role="combobox"]') ? direct :
        (direct || root).querySelector('input:not([type="hidden"]):not(:disabled), textarea:not(:disabled), [role="combobox"], button');
      const destination = target || root;
      target?.focus({ preventScroll: true });
      destination.scrollIntoView?.({ behavior: window.matchMedia?.('(prefers-reduced-motion: reduce)')?.matches ? 'auto' : 'smooth', block: 'center' });
    }, 350);
  };
  const pendingBySection = Object.fromEntries(REQUIREMENT_SECTIONS.map(section => [section.id, 0]));
  Object.keys(currentValidation.fieldErrors).forEach(field => { pendingBySection[sectionForRequirementField(field)] += 1; });

  return (
    <Container>
      <FormContainer>
        <Paper elevation={0} sx={{ p: { xs: 1, sm: 2, md: 3 }, borderRadius: 3, bgcolor: "#f4f7fb" }}>
          {/* Cabeçalho */}
          <Box textAlign="center" mb={4}>
            <Typography
              variant="h4"
              component="h1"
              color="primary"
              gutterBottom
            >
              {TITULO_REQUERIMENTO}
            </Typography>
            <Typography variant="body1" color="text.secondary">
              COLÉGIO AUTÊNTICO
            </Typography>
            <Typography variant="body2" color="text.secondary" sx={{ mt: 1 }}>
              Confira as seções com campos a completar. As demais ficam recolhidas e podem ser abertas para revisão.
            </Typography>
          </Box>

          {studentData?.enrollmentContractStatusError && <Alert severity="warning" sx={{ mb: 2 }}>Não foi possível recuperar os dados anteriores de contrato, pagamento e imagem. Confira e preencha os campos; você pode salvar e gerar o PDF normalmente.</Alert>}
          {/* Busca de Aluno */}
          <Box textAlign="center" mb={4}>
            <Typography variant="h6" color="primary" gutterBottom>
              Buscar Aluno para Preenchimento Automático
            </Typography>
            <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
              Selecione um aluno para preencher automaticamente os dados do
              formulário
            </Typography>
            {/* Filtro de situação: Pré-matrícula (6) ou Ativo (1) */}
            <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', mb: 1, gap: 2 }}>
              <FormControlLabel
                control={
                  <Checkbox
                    checked={isPreMatricula}
                    onChange={(e) => {
                      setIsPreMatricula(e.target.checked);
                      setSearchValue("");
                    }}
                  />
                }
                label="Pré-matrícula"
              />
            </Box>

            <Autocomplete
              onChange={handleStudentSelect}
              disablePortal
              options={filteredStudents}
              value={selectedStudent}
              inputValue={searchValue}
              onInputChange={(_, value) => setSearchValue(value)}
              getOptionLabel={(option) => option.Aluno || ""}
              isOptionEqualToValue={(option, value) => option.AlunoID === value.AlunoID}
              filterOptions={(options) => options}
              renderOption={(props, option) => (
                <li {...props} key={option.AlunoID}>
                  {option.Aluno} — ID {option.AlunoID}
                </li>
              )}
              loading={listLoading}
              loadingText="Carregando lista de alunos…"
              noOptionsText={listError || "Nenhum aluno encontrado para esta busca."}
              sx={{ width: { xs: "100%", md: "85%" }, margin: "0 auto" }}
              renderInput={(params) => (
                <TextField
                  {...params}
                  label="Buscar aluno pelo nome"
                  error={Boolean(listError)}
                  helperText={
                    listError || "Busque por partes do nome, mesmo sem acentos. Até 50 resultados por busca."
                  }
                />
              )}
            />
            
            <Button onClick={retryList} disabled={listLoading || studentLoading}>
              {listError ? "Tentar carregar lista novamente" : "Atualizar lista"}
            </Button>
            {studentLoading && <Typography role="status" sx={{ mt: 2 }}>Carregando dados do aluno e dos responsáveis…</Typography>}
            {studentError && (
              <Alert severity="error" sx={{ mt: 2 }} action={<Button onClick={retryStudent}>Tentar novamente</Button>}>
                {studentError}
              </Alert>
            )}
            {financialLoading && (
              <Alert severity="info" sx={{ mt: 2 }}>Verificando pendências financeiras…</Alert>
            )}
            {financialError && <Alert severity="warning" sx={{ mt: 2 }}>{financialError}</Alert>}
            {financialStatus?.hasOpenInstallments && (
              <Alert severity="warning" sx={{ mt: 2, textAlign: 'left' }}>
                INFORMAÇÃO FINANCEIRA: o aluno possui {financialStatus.count}{' '}
                {financialStatus.count === 1 ? 'parcela pendente' : 'parcelas pendentes'} com vencimento até{' '}
                {financialCheckDate}, data de preenchimento deste requerimento.
                Este aviso é apenas informativo e não impede o requerimento.
              </Alert>
            )}
            {financialStatus && !financialStatus.hasOpenInstallments && (
              <Alert severity="success" sx={{ mt: 2 }}>
                Nenhuma parcela pendente com vencimento até {financialCheckDate}, data de preenchimento deste requerimento.
              </Alert>
            )}
            {selectedStudent && (
              <Box mt={2}>
                <Typography variant="body2" color="success.main">
                  ✓ Aluno selecionado: <strong>{selectedStudent.Aluno}</strong>
                </Typography>
                
                {/* Alerta de dados atualizados */}
                {showUpdateAlert && lastUpdateDate && (
                  <Box mt={1} p={2} sx={{ 
                    backgroundColor: '#ffebee', 
                    border: '1px solid #f44336', 
                    borderRadius: 1,
                    borderLeft: '4px solid #f44336'
                  }}>
                    <Typography variant="body2" sx={{ 
                      color: '#d32f2f', 
                      fontWeight: 'bold',
                      fontSize: '0.9rem'
                    }}>
                      ⚠️ DADOS ATUALIZADOS EM: {lastUpdateDate}
                    </Typography>
                    <Typography variant="caption" sx={{ 
                      color: '#d32f2f',
                      display: 'block',
                      mt: 0.5
                    }}>
                      Este formulário foi modificado recentemente. Verifique se as informações estão corretas.
                    </Typography>
                    
                    {/* Botão do Google Drive */}
                    {googleDriveLink && (
                      <Box mt={1} sx={{ display: 'flex', justifyContent: 'center' }}>
                        <Button
                          size="small"
                          variant="outlined"
                          startIcon={
                            <img 
                              src="https://www.gstatic.com/images/branding/product/2x/drive_2020q4_48dp.png" 
                              alt="Google Drive" 
                              style={{ width: 16, height: 16 }}
                            />
                          }
                          onClick={() => window.open(googleDriveLink, '_blank')}
                          sx={{ 
                            fontSize: '0.75rem',
                            py: 0.5,
                            px: 1,
                            borderColor: '#d32f2f',
                            color: '#d32f2f',
                            '&:hover': {
                              borderColor: '#b71c1c',
                              backgroundColor: '#ffebee'
                            }
                          }}
                        >
                          Ver Documentos
                        </Button>
                      </Box>
                    )}
                  </Box>
                )}
                
                {studentData && (
                  <Typography variant="body2" color="info.main">
                    ✓ Dados carregados e formulário preenchido automaticamente
                  </Typography>
                )}
              </Box>
            )}
          </Box>

          <RequerimentoSection key={`${formSession}-aluno`} sectionId="aluno" pending={pendingBySection.aluno} onComplete={advanceToNextRequired} openRequest={sectionOpenRequest.id === "aluno" ? sectionOpenRequest.token : 0}>
            
            <FieldRow>
              <FieldGroup xs={12}>
                <FieldLabel htmlFor="requerimento-campo-nomeCompleto">Nome Completo do Aluno *</FieldLabel>
                <FieldInput id="requerimento-campo-nomeCompleto" name="nomeCompleto"
                  fullWidth
                  value={formData.nomeCompleto}
                  onChange={(e) =>
                    handleInputChange("nomeCompleto", e.target.value)
                  }
                  required
                  error={fieldErrors.nomeCompleto}
                  helperText={
                    fieldErrors.nomeCompleto ? "Campo obrigatório" : ""
                  }
                />
              </FieldGroup>
            </FieldRow>

            <FieldRow>
              <FieldGroup xs={12} sm={6}>
                <FieldLabel htmlFor="requerimento-campo-dataNascimento">Data de Nascimento *</FieldLabel>
                <FieldInput id="requerimento-campo-dataNascimento" name="dataNascimento"
                  fullWidth
                  value={formData.dataNascimento}
                  onChange={(e) =>
                    handleInputChange("dataNascimento", e.target.value)
                  }
                  placeholder="dd/mm/aaaa"
                  helperText={
                    fieldErrors.dataNascimento
                      ? "Campo obrigatório"
                      : "Formato: dd/mm/aaaa"
                  }
                  required
                  error={fieldErrors.dataNascimento}
                />
              </FieldGroup>
              <FieldGroup xs={12} sm={6}>
                <FieldLabel>Naturalidade *</FieldLabel>
                <NaturalidadeField id="requerimento-campo-naturalidade"
                  value={formData.naturalidade}
                  onChange={(value) => handleInputChange("naturalidade", value)}
                  error={fieldErrors.naturalidade}
                  isBrazilian={/^brasileir/i.test(formData.nacionalidade?.trim() || "")}
                />
              </FieldGroup>
              <FieldGroup xs={12} sm={6}>
                <FieldLabel htmlFor="requerimento-campo-nacionalidade">Nacionalidade *</FieldLabel>
                <FieldInput id="requerimento-campo-nacionalidade" name="nacionalidade"
                  fullWidth
                  value={formData.nacionalidade}
                  onChange={(e) =>
                    handleInputChange("nacionalidade", e.target.value)
                  }
                  required
                  error={fieldErrors.nacionalidade}
                  helperText={
                    fieldErrors.nacionalidade ? "Campo obrigatório" : ""
                  }
                />
              </FieldGroup>
            </FieldRow>

            <FieldRow>
              <FieldGroup xs={12} sm={6}>
                <FieldLabel htmlFor="requerimento-campo-cpf">CPF do Aluno *</FieldLabel>
                <FieldInput id="requerimento-campo-cpf" name="cpf"
                  fullWidth
                  value={formData.cpf}
                  onChange={(e) => handleInputChange("cpf", e.target.value)}
                  placeholder="000.000.000-00"
                  helperText={
                    fieldErrors.cpf
                      ? "Campo obrigatório"
                      : "Digite apenas os números"
                  }
                  required
                  error={fieldErrors.cpf}
                />
              </FieldGroup>
              <FieldGroup xs={12} sm={6}>
                <FieldLabel htmlFor="requerimento-campo-rg">RG do Aluno</FieldLabel>
                <FieldInput id="requerimento-campo-rg" name="rg"
                  fullWidth
                  value={formData.rg}
                  onChange={(e) => handleInputChange("rg", e.target.value)}
                />
              </FieldGroup>
            </FieldRow>

            <FieldRow>
              <FieldGroup xs={12} sm={6}>
                <FieldLabel htmlFor="requerimento-campo-endereco">Endereço *</FieldLabel>
                <FieldInput id="requerimento-campo-endereco" name="endereco"
                  fullWidth
                  value={formData.endereco}
                  onChange={(e) =>
                    handleInputChange("endereco", e.target.value)
                  }
                  required
                  error={fieldErrors.endereco}
                  helperText={fieldErrors.endereco ? "Campo obrigatório" : ""}
                />
              </FieldGroup>
              <FieldGroup xs={12} sm={6}>
                <FieldLabel htmlFor="requerimento-campo-numeroEndereco">Número da Residência</FieldLabel>
                <FieldInput id="requerimento-campo-numeroEndereco" name="numeroEndereco"
                  fullWidth
                  value={formData.numeroEndereco}
                  onChange={(e) =>
                    handleInputChange("numeroEndereco", e.target.value)
                  }
                  placeholder="123"
                />
              </FieldGroup>
            </FieldRow>

            <FieldRow>
              <FieldGroup xs={12} sm={6}>
                <FieldLabel htmlFor="requerimento-campo-bairro">Bairro *</FieldLabel>
                <FieldInput id="requerimento-campo-bairro" name="bairro"
                  fullWidth
                  value={formData.bairro}
                  onChange={(e) => handleInputChange("bairro", e.target.value)}
                  required
                  error={fieldErrors.bairro}
                  helperText={fieldErrors.bairro ? "Campo obrigatório" : ""}
                />
              </FieldGroup>
              <FieldGroup xs={12} sm={6}>
                <FieldLabel htmlFor="requerimento-campo-cidade">Cidade *</FieldLabel>
                <FieldInput id="requerimento-campo-cidade" name="cidade"
                  fullWidth
                  value={formData.cidade}
                  onChange={(e) => handleInputChange("cidade", e.target.value)}
                  required
                  error={fieldErrors.cidade}
                  helperText={fieldErrors.cidade ? "Campo obrigatório" : ""}
                />
              </FieldGroup>
            </FieldRow>

            <FieldRow>
              <FieldGroup xs={12} sm={6}>
                <FieldLabel htmlFor="requerimento-campo-cep">CEP *</FieldLabel>
                <FieldInput id="requerimento-campo-cep" name="cep"
                  fullWidth
                  value={formData.cep}
                  onChange={(e) => handleInputChange("cep", e.target.value)}
                  placeholder="00000-000"
                  required
                  error={fieldErrors.cep}
                  helperText={fieldErrors.cep ? "Campo obrigatório" : ""}
                />
              </FieldGroup>
              <FieldGroup xs={12} sm={6}>
                <FieldLabel htmlFor="requerimento-campo-complemento">Complemento</FieldLabel>
                <FieldInput id="requerimento-campo-complemento" name="complemento"
                  fullWidth
                  value={formData.complemento}
                  onChange={(e) =>
                    handleInputChange("complemento", e.target.value)
                  }
                />
              </FieldGroup>
            </FieldRow>

            <FieldRow>
              <FieldGroup xs={12} sm={6}>
                <FieldLabel htmlFor="requerimento-campo-telefones">Telefone(s) *</FieldLabel>
                <FieldInput id="requerimento-campo-telefones" name="telefones"
                  fullWidth
                  value={formData.telefones}
                  onChange={(e) =>
                    handleInputChange("telefones", e.target.value)
                  }
                  placeholder="(00) 00000-0000"
                  required
                  error={fieldErrors.telefones}
                  helperText={fieldErrors.telefones ? "Campo obrigatório" : ""}
                />
              </FieldGroup>
              <FieldGroup xs={12} sm={6}>
                <FieldLabel htmlFor="requerimento-campo-emailResponsavel">E-mail (Responsável)</FieldLabel>
                <FieldInput id="requerimento-campo-emailResponsavel" name="emailResponsavel"
                  fullWidth
                  type="email"
                  value={formData.emailResponsavel}
                  onChange={(e) =>
                    handleInputChange("emailResponsavel", e.target.value)
                  }
                  placeholder="email@exemplo.com"
                />
              </FieldGroup>
            </FieldRow>

            <FieldRow>
              <FieldGroup xs={12} sm={6}>
                <FieldLabel htmlFor="requerimento-campo-escolaAnterior">Escola Anterior *</FieldLabel>
                <FieldInput id="requerimento-campo-escolaAnterior" name="escolaAnterior"
                  fullWidth
                  value={formData.escolaAnterior}
                  onChange={(e) =>
                    handleInputChange("escolaAnterior", e.target.value)
                  }
                  required
                  error={fieldErrors.escolaAnterior}
                  helperText={
                    fieldErrors.escolaAnterior ? "Campo obrigatório" : ""
                  }
                />
              </FieldGroup>
              <FieldGroup xs={12} sm={6}>
                <FieldLabel htmlFor="requerimento-campo-anoSerie">Ano/Série que pretende cursar *</FieldLabel>
                <FieldInput id="requerimento-campo-anoSerie" name="anoSerie"
                  fullWidth
                  value={formData.anoSerie}
                  onChange={(e) =>
                    handleInputChange("anoSerie", e.target.value)
                  }
                  required
                  error={fieldErrors.anoSerie}
                  helperText={fieldErrors.anoSerie ? "Campo obrigatório" : ""}
                />
              </FieldGroup>
            </FieldRow>

            <FieldRow>
              <FieldGroup xs={12} sm={6}>
                <FieldLabel>Nível *</FieldLabel>
                <FormControl fullWidth error={fieldErrors.nivel}>
                  <Select id="requerimento-campo-nivel"
                    value={formData.nivel}
                    onChange={(e) => handleInputChange("nivel", e.target.value)}
                    displayEmpty
                    required
                  >
                    <MenuItem value="">Selecione o nível</MenuItem>
                    {niveis.map((nivel) => (
                      <MenuItem key={nivel} value={nivel}>
                        {nivel}
                      </MenuItem>
                    ))}
                  </Select>
                  {fieldErrors.nivel && (
                    <Typography
                      variant="caption"
                      color="error"
                      sx={{ mt: 1, display: "block" }}
                    >
                      Campo obrigatório
                    </Typography>
                  )}
                </FormControl>
              </FieldGroup>
              <FieldGroup xs={12} sm={6}>
                <FieldLabel>Turno *</FieldLabel>
                <FormControl fullWidth error={fieldErrors.turno}>
                  <Select id="requerimento-campo-turno"
                    value={formData.turno}
                    onChange={(e) => handleInputChange("turno", e.target.value)}
                    displayEmpty
                    required
                  >
                    <MenuItem value="">Selecione o turno</MenuItem>
                    {turnos.map((turno) => (
                      <MenuItem key={turno} value={turno}>
                        {turno}
                      </MenuItem>
                    ))}
                  </Select>
                  {fieldErrors.turno && (
                    <Typography
                      variant="caption"
                      color="error"
                      sx={{ mt: 1, display: "block" }}
                    >
                      Campo obrigatório
                    </Typography>
                  )}
                </FormControl>
              </FieldGroup>
            </FieldRow>
          </RequerimentoSection>

          <FormDivider />

          {/* FILIAÇÃO - DADOS DOS PAIS */}
          <RequerimentoSection key={`${formSession}-filiacao`} sectionId="filiacao" pending={pendingBySection.filiacao} onComplete={advanceToNextRequired} openRequest={sectionOpenRequest.id === "filiacao" ? sectionOpenRequest.token : 0}>
            
            <FieldRow>
              <FieldGroup xs={12}>
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={formData.naoTemPai}
                      onChange={(e) =>
                        handleInputChange("naoTemPai", e.target.checked)
                      }
                      color="primary"
                    />
                  }
                  label="Aluno NÃO possui pai (marque se não possuir)"
                />
              </FieldGroup>
            </FieldRow>
            
            {!formData.naoTemPai && (
              <>
            <FieldRow>
              <FieldGroup xs={12}>
                    <FieldLabel htmlFor="requerimento-campo-nomePai">Nome do Pai *</FieldLabel>
                <FieldInput id="requerimento-campo-nomePai" name="nomePai"
                  fullWidth
                  value={formData.nomePai}
                      onChange={(e) =>
                        handleInputChange("nomePai", e.target.value)
                      }
                  placeholder="Nome completo do pai"
                      required
                      error={fieldErrors.nomePai}
                      helperText={
                        fieldErrors.nomePai ? "Campo obrigatório" : ""
                      }
                />
              </FieldGroup>
            </FieldRow>
            <FieldRow>
              <FieldGroup xs={12} sm={6}>
                    <FieldLabel htmlFor="requerimento-campo-cpfPai">CPF *</FieldLabel>
                <FieldInput id="requerimento-campo-cpfPai" name="cpfPai"
                  fullWidth
                  value={formData.cpfPai}
                      onChange={(e) =>
                        handleInputChange("cpfPai", e.target.value)
                      }
                  placeholder="000.000.000-00"
                      required
                      error={fieldErrors.cpfPai}
                      helperText={fieldErrors.cpfPai ? "Campo obrigatório" : ""}
                />
              </FieldGroup>
              <FieldGroup xs={12} sm={6}>
                    <FieldLabel htmlFor="requerimento-campo-identidadePai">Carteira de Identidade *</FieldLabel>
                <FieldInput id="requerimento-campo-identidadePai" name="identidadePai"
                  fullWidth
                  value={formData.identidadePai}
                      onChange={(e) =>
                        handleInputChange("identidadePai", e.target.value)
                      }
                      required
                      error={fieldErrors.identidadePai}
                      helperText={
                        fieldErrors.identidadePai ? "Campo obrigatório" : ""
                      }
                />
              </FieldGroup>
            </FieldRow>

            <FieldRow>
              <FieldGroup xs={12} sm={6}>
                    <FieldLabel htmlFor="requerimento-campo-dataNascimentoPai">Data de Nascimento *</FieldLabel>
                <FieldInput id="requerimento-campo-dataNascimentoPai" name="dataNascimentoPai"
                  fullWidth
                  value={formData.dataNascimentoPai}
                      onChange={(e) =>
                        handleInputChange("dataNascimentoPai", e.target.value)
                      }
                  placeholder="dd/mm/aaaa"
                      helperText={
                        fieldErrors.dataNascimentoPai
                          ? "Campo obrigatório"
                          : "Formato: dd/mm/aaaa"
                      }
                      required
                      error={fieldErrors.dataNascimentoPai}
                />
              </FieldGroup>
            </FieldRow>

                <FieldRow></FieldRow>

            <FieldRow>
              <FieldGroup xs={12} sm={6}>
                    <FieldLabel htmlFor="requerimento-campo-enderecoPai">Endereço *</FieldLabel>
                <FieldInput id="requerimento-campo-enderecoPai" name="enderecoPai"
                  fullWidth
                  value={formData.enderecoPai}
                      onChange={(e) =>
                        handleInputChange("enderecoPai", e.target.value)
                      }
                      required
                      error={fieldErrors.enderecoPai}
                      helperText={
                        fieldErrors.enderecoPai ? "Campo obrigatório" : ""
                      }
                />
              </FieldGroup>
              <FieldGroup xs={12} sm={6}>
                    <FieldLabel htmlFor="requerimento-campo-numeroEnderecoPai">Número da Residência *</FieldLabel>
                <FieldInput id="requerimento-campo-numeroEnderecoPai" name="numeroEnderecoPai"
                  fullWidth
                  value={formData.numeroEnderecoPai}
                      onChange={(e) =>
                        handleInputChange("numeroEnderecoPai", e.target.value)
                      }
                  placeholder="123"
                      required
                      error={fieldErrors.numeroEnderecoPai}
                      helperText={
                        fieldErrors.numeroEnderecoPai ? "Campo obrigatório" : ""
                      }
                />
              </FieldGroup>
            </FieldRow>

            <FieldRow>
              <FieldGroup xs={12} sm={6}>
                <FieldLabel htmlFor="requerimento-campo-complementoPai">Complemento</FieldLabel>
                <FieldInput id="requerimento-campo-complementoPai" name="complementoPai"
                  fullWidth
                  value={formData.complementoPai}
                      onChange={(e) =>
                        handleInputChange("complementoPai", e.target.value)
                      }
                />
              </FieldGroup>
              <FieldGroup xs={12} sm={6}>
                    <FieldLabel htmlFor="requerimento-campo-cepPai">CEP *</FieldLabel>
                <FieldInput id="requerimento-campo-cepPai" name="cepPai"
                  fullWidth
                  value={formData.cepPai}
                      onChange={(e) =>
                        handleInputChange("cepPai", e.target.value)
                      }
                  placeholder="00000-000"
                      required
                      error={fieldErrors.cepPai}
                      helperText={fieldErrors.cepPai ? "Campo obrigatório" : ""}
                />
              </FieldGroup>
            </FieldRow>

            <FieldRow>
              <FieldGroup xs={12} sm={6}>
                    <FieldLabel htmlFor="requerimento-campo-telefonePai">Telefone/WhatsApp *</FieldLabel>
                <FieldInput id="requerimento-campo-telefonePai" name="telefonePai"
                  fullWidth
                  value={formData.telefonePai}
                      onChange={(e) =>
                        handleInputChange("telefonePai", e.target.value)
                      }
                  placeholder="(00) 00000-0000"
                      required
                      error={fieldErrors.telefonePai}
                      helperText={
                        fieldErrors.telefonePai ? "Campo obrigatório" : ""
                      }
                />
              </FieldGroup>
              <FieldGroup xs={12} sm={6}>
                    <FieldLabel htmlFor="requerimento-campo-bairroPai">Bairro *</FieldLabel>
                <FieldInput id="requerimento-campo-bairroPai" name="bairroPai"
                  fullWidth
                  value={formData.bairroPai}
                      onChange={(e) =>
                        handleInputChange("bairroPai", e.target.value)
                      }
                      required
                      error={fieldErrors.bairroPai}
                      helperText={
                        fieldErrors.bairroPai ? "Campo obrigatório" : ""
                      }
                />
              </FieldGroup>
            </FieldRow>

            <FieldRow>
              <FieldGroup xs={12} sm={6}>
                <FieldLabel htmlFor="requerimento-campo-emailPai">E-mail</FieldLabel>
                <FieldInput id="requerimento-campo-emailPai" name="emailPai"
                  fullWidth
                  type="email"
                  value={formData.emailPai}
                      onChange={(e) =>
                        handleInputChange("emailPai", e.target.value)
                      }
                  placeholder="email@exemplo.com"
                />
              </FieldGroup>
                  
            </FieldRow>
              </>
            )}

            <FieldRow>
              <FieldGroup xs={12}>
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={formData.naoTemMae}
                      onChange={(e) =>
                        handleInputChange("naoTemMae", e.target.checked)
                      }
                      color="primary"
                    />
                  }
                  label="Aluno NÃO possui mãe (marque se não possuir)"
                />
              </FieldGroup>
            </FieldRow>
            
            {!formData.naoTemMae && (
              <>
            <FieldRow>
              <FieldGroup xs={12}>
                    <FieldLabel htmlFor="requerimento-campo-nomeMae">Nome da Mãe *</FieldLabel>
                <FieldInput id="requerimento-campo-nomeMae" name="nomeMae"
                  fullWidth
                  value={formData.nomeMae}
                      onChange={(e) =>
                        handleInputChange("nomeMae", e.target.value)
                      }
                  placeholder="Nome completo da mãe"
                      required
                      error={fieldErrors.nomeMae}
                      helperText={
                        fieldErrors.nomeMae ? "Campo obrigatório" : ""
                      }
                />
              </FieldGroup>
            </FieldRow>
            <FieldRow>
              <FieldGroup xs={12} sm={6}>
                    <FieldLabel htmlFor="requerimento-campo-cpfMae">CPF *</FieldLabel>
                <FieldInput id="requerimento-campo-cpfMae" name="cpfMae"
                  fullWidth
                  value={formData.cpfMae}
                      onChange={(e) =>
                        handleInputChange("cpfMae", e.target.value)
                      }
                  placeholder="000.000.000-00"
                      required
                      error={fieldErrors.cpfMae}
                      helperText={fieldErrors.cpfMae ? "Campo obrigatório" : ""}
                />
              </FieldGroup>
              <FieldGroup xs={12} sm={6}>
                    <FieldLabel htmlFor="requerimento-campo-identidadeMae">Carteira de Identidade *</FieldLabel>
                <FieldInput id="requerimento-campo-identidadeMae" name="identidadeMae"
                  fullWidth
                  value={formData.identidadeMae}
                      onChange={(e) =>
                        handleInputChange("identidadeMae", e.target.value)
                      }
                      required
                      error={fieldErrors.identidadeMae}
                      helperText={
                        fieldErrors.identidadeMae ? "Campo obrigatório" : ""
                      }
                />
              </FieldGroup>
            </FieldRow>

            <FieldRow>
              <FieldGroup xs={12} sm={6}>
                    <FieldLabel htmlFor="requerimento-campo-dataNascimentoMae">Data de Nascimento *</FieldLabel>
                <FieldInput id="requerimento-campo-dataNascimentoMae" name="dataNascimentoMae"
                  fullWidth
                  value={formData.dataNascimentoMae}
                      onChange={(e) =>
                        handleInputChange("dataNascimentoMae", e.target.value)
                      }
                  placeholder="dd/mm/aaaa"
                      helperText={
                        fieldErrors.dataNascimentoMae
                          ? "Campo obrigatório"
                          : "Formato: dd/mm/aaaa"
                      }
                      required
                      error={fieldErrors.dataNascimentoMae}
                />
              </FieldGroup>
            </FieldRow>

                <FieldRow></FieldRow>

            <FieldRow>
              <FieldGroup xs={12} sm={6}>
                    <FieldLabel htmlFor="requerimento-campo-enderecoMae">Endereço *</FieldLabel>
                <FieldInput id="requerimento-campo-enderecoMae" name="enderecoMae"
                  fullWidth
                  value={formData.enderecoMae}
                      onChange={(e) =>
                        handleInputChange("enderecoMae", e.target.value)
                      }
                      required
                      error={fieldErrors.enderecoMae}
                      helperText={
                        fieldErrors.enderecoMae ? "Campo obrigatório" : ""
                      }
                />
              </FieldGroup>
              <FieldGroup xs={12} sm={6}>
                    <FieldLabel htmlFor="requerimento-campo-numeroEnderecoMae">Número da Residência *</FieldLabel>
                <FieldInput id="requerimento-campo-numeroEnderecoMae" name="numeroEnderecoMae"
                  fullWidth
                  value={formData.numeroEnderecoMae}
                      onChange={(e) =>
                        handleInputChange("numeroEnderecoMae", e.target.value)
                      }
                  placeholder="123"
                      required
                      error={fieldErrors.numeroEnderecoMae}
                      helperText={
                        fieldErrors.numeroEnderecoMae ? "Campo obrigatório" : ""
                      }
                />
              </FieldGroup>
            </FieldRow>

            <FieldRow>
              <FieldGroup xs={12} sm={6}>
                <FieldLabel htmlFor="requerimento-campo-complementoMae">Complemento</FieldLabel>
                <FieldInput id="requerimento-campo-complementoMae" name="complementoMae"
                  fullWidth
                  value={formData.complementoMae}
                      onChange={(e) =>
                        handleInputChange("complementoMae", e.target.value)
                      }
                />
              </FieldGroup>
              <FieldGroup xs={12} sm={6}>
                    <FieldLabel htmlFor="requerimento-campo-cepMae">CEP *</FieldLabel>
                <FieldInput id="requerimento-campo-cepMae" name="cepMae"
                  fullWidth
                  value={formData.cepMae}
                      onChange={(e) =>
                        handleInputChange("cepMae", e.target.value)
                      }
                  placeholder="00000-000"
                      required
                      error={fieldErrors.cepMae}
                      helperText={fieldErrors.cepMae ? "Campo obrigatório" : ""}
                />
              </FieldGroup>
            </FieldRow>

            <FieldRow>
              <FieldGroup xs={12} sm={6}>
                    <FieldLabel htmlFor="requerimento-campo-telefoneMae">Telefone/WhatsApp *</FieldLabel>
                <FieldInput id="requerimento-campo-telefoneMae" name="telefoneMae"
                  fullWidth
                  value={formData.telefoneMae}
                      onChange={(e) =>
                        handleInputChange("telefoneMae", e.target.value)
                      }
                  placeholder="(00) 00000-0000"
                      required
                      error={fieldErrors.telefoneMae}
                      helperText={
                        fieldErrors.telefoneMae ? "Campo obrigatório" : ""
                      }
                />
              </FieldGroup>
              <FieldGroup xs={12} sm={6}>
                    <FieldLabel htmlFor="requerimento-campo-bairroMae">Bairro *</FieldLabel>
                <FieldInput id="requerimento-campo-bairroMae" name="bairroMae"
                  fullWidth
                  value={formData.bairroMae}
                      onChange={(e) =>
                        handleInputChange("bairroMae", e.target.value)
                      }
                      required
                      error={fieldErrors.bairroMae}
                      helperText={
                        fieldErrors.bairroMae ? "Campo obrigatório" : ""
                      }
                />
              </FieldGroup>
            </FieldRow>

            <FieldRow>
              <FieldGroup xs={12} sm={6}>
                <FieldLabel htmlFor="requerimento-campo-emailMae">E-mail</FieldLabel>
                <FieldInput id="requerimento-campo-emailMae" name="emailMae"
                  fullWidth
                  type="email"
                  value={formData.emailMae}
                      onChange={(e) =>
                        handleInputChange("emailMae", e.target.value)
                      }
                  placeholder="email@exemplo.com"
                />
              </FieldGroup>
                  
            </FieldRow>
              </>
            )}
          </RequerimentoSection>

          <FormDivider />

          {/* RESPONSÁVEL FINANCEIRO */}
          <RequerimentoSection key={`${formSession}-financeiro`} sectionId="financeiro" pending={pendingBySection.financeiro} onComplete={advanceToNextRequired} openRequest={sectionOpenRequest.id === "financeiro" ? sectionOpenRequest.token : 0}>
            
            <FieldRow>
              <FieldGroup xs={12}>
                <FieldLabel>Selecione o responsável financeiro: *</FieldLabel>
                <FormControl
                  fullWidth
                  error={fieldErrors.responsavelFinanceiro}
                >
                  <Select id="requerimento-campo-responsavelFinanceiro"
                    value={formData.responsavelFinanceiro}
                    onChange={(e) =>
                      handleInputChange("responsavelFinanceiro", e.target.value)
                    }
                    displayEmpty
                    required
                  >
                    <MenuItem value="">
                      Selecione o responsável financeiro
                    </MenuItem>
                    <MenuItem value="pai">PAI</MenuItem>
                    <MenuItem value="mae">MÃE</MenuItem>
                    <MenuItem value="outro">OUTRO</MenuItem>
                  </Select>
                  {fieldErrors.responsavelFinanceiro ? (
                    <Typography
                      variant="caption"
                      color="error"
                      sx={{ mt: 1, display: "block" }}
                    >
                      Campo obrigatório
                    </Typography>
                  ) : (
                    <Typography
                      variant="caption"
                      color="text.secondary"
                      sx={{ mt: 1, display: "block" }}
                    >
                  (Preencher os dados abaixo, caso não seja o pai ou a mãe)
                </Typography>
                  )}
                </FormControl>
              </FieldGroup>
            </FieldRow>

            {formData.responsavelFinanceiro === "outro" && (
              <>
                <FieldRow>
                  <FieldGroup xs={12}>
                    <FieldLabel htmlFor="requerimento-campo-nomeResponsavel">Nome do Responsável *</FieldLabel>
                    <FieldInput id="requerimento-campo-nomeResponsavel" name="nomeResponsavel"
                      fullWidth
                      value={formData.nomeResponsavel}
                      onChange={(e) =>
                        handleInputChange("nomeResponsavel", e.target.value)
                      }
                      placeholder="Nome completo do responsável"
                      error={fieldErrors.nomeResponsavel}
                      helperText={
                        fieldErrors.nomeResponsavel ? "Campo obrigatório" : ""
                      }
                    />
                  </FieldGroup>
                </FieldRow>
                <FieldRow>
                  <FieldGroup xs={12} sm={6}>
                    <FieldLabel htmlFor="requerimento-campo-cpfResponsavel">CPF</FieldLabel>
                    <FieldInput id="requerimento-campo-cpfResponsavel" name="cpfResponsavel"
                      fullWidth
                      value={formData.cpfResponsavel}
                      onChange={(e) =>
                        handleInputChange("cpfResponsavel", e.target.value)
                      }
                      placeholder="000.000.000-00"
                    />
                  </FieldGroup>
                  <FieldGroup xs={12} sm={6}>
                    <FieldLabel htmlFor="requerimento-campo-identidadeResponsavel">Carteira de Identidade</FieldLabel>
                    <FieldInput id="requerimento-campo-identidadeResponsavel" name="identidadeResponsavel"
                      fullWidth
                      value={formData.identidadeResponsavel}
                      onChange={(e) =>
                        handleInputChange(
                          "identidadeResponsavel",
                          e.target.value
                        )
                      }
                    />
                  </FieldGroup>
                </FieldRow>

                <FieldRow>
                  <FieldGroup xs={12} sm={6}>
                    <FieldLabel htmlFor="requerimento-campo-dataNascimentoResponsavel">Data de Nascimento</FieldLabel>
                    <FieldInput id="requerimento-campo-dataNascimentoResponsavel" name="dataNascimentoResponsavel"
                      fullWidth
                      value={formData.dataNascimentoResponsavel}
                      onChange={(e) =>
                        handleInputChange(
                          "dataNascimentoResponsavel",
                          e.target.value
                        )
                      }
                      placeholder="dd/mm/aaaa"
                      helperText="Formato: dd/mm/aaaa"
                    />
                  </FieldGroup>
                </FieldRow>

                <FieldRow>
                  <FieldGroup xs={12}>
                    <FieldLabel htmlFor="requerimento-campo-enderecoResponsavel">Endereço</FieldLabel>
                    <FieldInput id="requerimento-campo-enderecoResponsavel" name="enderecoResponsavel"
                      fullWidth
                      value={formData.enderecoResponsavel}
                      onChange={(e) =>
                        handleInputChange("enderecoResponsavel", e.target.value)
                      }
                    />
                  </FieldGroup>
                </FieldRow>

                <FieldRow>
                  <FieldGroup xs={12} sm={6}>
                    <FieldLabel htmlFor="requerimento-campo-complementoResponsavel">Complemento</FieldLabel>
                    <FieldInput id="requerimento-campo-complementoResponsavel" name="complementoResponsavel"
                      fullWidth
                      value={formData.complementoResponsavel}
                      onChange={(e) =>
                        handleInputChange(
                          "complementoResponsavel",
                          e.target.value
                        )
                      }
                    />
                  </FieldGroup>
                  <FieldGroup xs={12} sm={6}>
                    <FieldLabel htmlFor="requerimento-campo-cepResponsavel">CEP</FieldLabel>
                    <FieldInput id="requerimento-campo-cepResponsavel" name="cepResponsavel"
                      fullWidth
                      value={formData.cepResponsavel}
                      onChange={(e) =>
                        handleInputChange("cepResponsavel", e.target.value)
                      }
                      placeholder="00000-000"
                    />
                  </FieldGroup>
                </FieldRow>

                <FieldRow>
                  <FieldGroup xs={12} sm={6}>
                    <FieldLabel htmlFor="requerimento-campo-telefoneResponsavel">Telefone/WhatsApp</FieldLabel>
                    <FieldInput id="requerimento-campo-telefoneResponsavel" name="telefoneResponsavel"
                      fullWidth
                      value={formData.telefoneResponsavel}
                      onChange={(e) =>
                        handleInputChange("telefoneResponsavel", e.target.value)
                      }
                      placeholder="(00) 00000-0000"
                    />
                  </FieldGroup>
                  <FieldGroup xs={12} sm={6}>
                    <FieldLabel htmlFor="requerimento-campo-bairroResponsavel">Bairro</FieldLabel>
                    <FieldInput id="requerimento-campo-bairroResponsavel" name="bairroResponsavel"
                      fullWidth
                      value={formData.bairroResponsavel}
                      onChange={(e) =>
                        handleInputChange("bairroResponsavel", e.target.value)
                      }
                    />
                  </FieldGroup>
                </FieldRow>

                <FieldRow>
                  <FieldGroup xs={12} sm={6}>
                    <FieldLabel htmlFor="requerimento-campo-emailResponsavelFinanceiro">E-mail</FieldLabel>
                    <FieldInput id="requerimento-campo-emailResponsavelFinanceiro" name="emailResponsavelFinanceiro"
                      fullWidth
                      type="email"
                      value={formData.emailResponsavelFinanceiro}
                      onChange={(e) =>
                        handleInputChange(
                          "emailResponsavelFinanceiro",
                          e.target.value
                        )
                      }
                      placeholder="email@exemplo.com"
                    />
                  </FieldGroup>
                  
                </FieldRow>
              </>
            )}
          </RequerimentoSection>

          <FormDivider />

          {/* RESPONSÁVEL PEDAGÓGICO */}
          <RequerimentoSection key={`${formSession}-pedagogico`} sectionId="pedagogico" pending={pendingBySection.pedagogico} onComplete={advanceToNextRequired} openRequest={sectionOpenRequest.id === "pedagogico" ? sectionOpenRequest.token : 0}>

            <FieldRow>
              <FieldGroup xs={12}>
                <FieldLabel>Selecione o responsável pedagógico: *</FieldLabel>
                <FormControl
                  fullWidth
                  error={fieldErrors.responsavelPedagogico}
                >
                  <Select id="requerimento-campo-responsavelPedagogico"
                    value={formData.responsavelPedagogico}
                    onChange={(e) =>
                      handleInputChange("responsavelPedagogico", e.target.value)
                    }
                    displayEmpty
                    required
                  >
                    <MenuItem value="">
                      Selecione o responsável pedagógico
                    </MenuItem>
                    <MenuItem value="pai">PAI</MenuItem>
                    <MenuItem value="mae">MÃE</MenuItem>
                    <MenuItem value="outro">OUTRO</MenuItem>
                  </Select>
                  {fieldErrors.responsavelPedagogico && (
                    <Typography
                      variant="caption"
                      color="error"
                      sx={{ mt: 1, display: "block" }}
                    >
                      Campo obrigatório
                    </Typography>
                  )}
                </FormControl>
              </FieldGroup>
            </FieldRow>
          </RequerimentoSection>

          <FormDivider />

          {/* ASPECTOS DE SAÚDE */}
          <RequerimentoSection key={`${formSession}-saude`} sectionId="saude" pending={pendingBySection.saude} onComplete={advanceToNextRequired} openRequest={sectionOpenRequest.id === "saude" ? sectionOpenRequest.token : 0}>
            <EnrollmentHealth key={studentData?.AlunoID || "novo"} form={formData} errors={fieldErrors} onFieldChange={handleInputChange} />
          </RequerimentoSection>

          <FormDivider />

          {/* AUTORIZAÇÕES */}
          <RequerimentoSection key={`${formSession}-autorizacoes`} sectionId="autorizacoes" pending={pendingBySection.autorizacoes} onComplete={advanceToNextRequired} openRequest={sectionOpenRequest.id === "autorizacoes" ? sectionOpenRequest.token : 0}>
            
            <FieldRow>
              <FieldGroup xs={12}>
                <FieldLabel>
                  O aluno pode sair sozinho após as aulas?
                </FieldLabel>
                <RadioGroup role="radiogroup" aria-label="Saída do aluno">
                  <FormControlLabel
                    control={<Radio />}
                    label="SIM"
                    value="sim"
                    checked={formData.autorizaSaidaSozinho === "sim"}
                    onChange={(e) =>
                      handleInputChange("autorizaSaidaSozinho", e.target.value)
                    }
                  />
                  <FormControlLabel
                    control={<Radio />}
                    label="NÃO"
                    value="nao"
                    checked={formData.autorizaSaidaSozinho === "nao"}
                    onChange={(e) =>
                      handleInputChange("autorizaSaidaSozinho", e.target.value)
                    }
                  />
                </RadioGroup>
              </FieldGroup>
            </FieldRow>

            {formData.autorizaSaidaSozinho === "nao" && <PickupAuthorization
              form={formData} errors={fieldErrors} onFieldChange={handleInputChange}
              onPatch={patch => {
                setFormDataRaw(previous => ({ ...previous, ...patch }));
                setFieldErrors(previous => Object.fromEntries(Object.entries(previous).filter(([key]) => !key.startsWith("saidaAcompanhada") && !key.startsWith("retirada"))));
              }}
            />}

            <FieldRow>
              <FieldGroup xs={12}>
                <FieldLabel>Autorização facultativa de uso de imagem e voz:</FieldLabel>
                <RadioGroup id="requerimento-campo-autorizaDireitoImagem">
                  <FormControlLabel
                    control={<Radio />}
                    label="AUTORIZO"
                    value="sim"
                    checked={formData.autorizaDireitoImagem === "sim"}
                    onChange={(e) =>
                      handleInputChange("autorizaDireitoImagem", e.target.value)
                    }
                  />
                  <FormControlLabel
                    control={<Radio />}
                    label="NÃO AUTORIZO"
                    value="nao"
                    checked={formData.autorizaDireitoImagem === "nao"}
                    onChange={(e) =>
                      handleInputChange("autorizaDireitoImagem", e.target.value)
                    }
                  />
                </RadioGroup>
                {fieldErrors.autorizaDireitoImagem && (
                  <FormHelperText error>Campo obrigatório</FormHelperText>
                )}
              </FieldGroup>
            </FieldRow>

            <FieldRow>
              <FieldGroup xs={12}>
                <FieldLabel htmlFor="requerimento-campo-restricoesDireitoImagem">Preferências/restrições específicas para imagem e voz:</FieldLabel>
                <FieldInput id="requerimento-campo-restricoesDireitoImagem" name="restricoesDireitoImagem"
                  fullWidth
                  multiline
                  minRows={2}
                  value={formData.restricoesDireitoImagem}
                  onChange={(e) =>
                    handleInputChange("restricoesDireitoImagem", e.target.value)
                  }
                  placeholder="Ex: autoriza apenas fotos coletivas, não publicar em redes sociais abertas..."
                />
              </FieldGroup>
            </FieldRow>
          </RequerimentoSection>

          <FormDivider />

          {/* OUTROS CAMPOS */}
          <RequerimentoSection key={`${formSession}-complementares`} sectionId="complementares" pending={pendingBySection.complementares} onComplete={advanceToNextRequired} openRequest={sectionOpenRequest.id === "complementares" ? sectionOpenRequest.token : 0}>
            <FieldRow>
              <FieldGroup xs={12}>
                <FieldLabel id="forma-pagamento-label">Forma de pagamento: *</FieldLabel>
                <FormControl fullWidth required error={Boolean(fieldErrors.formaPagamento)} sx={{ mb: 2 }}>
                  <Select id="requerimento-campo-formaPagamento" value={formData.formaPagamento} displayEmpty
                    labelId="forma-pagamento-label"
                    onChange={e => handleInputChange("formaPagamento", e.target.value)}>
                    <MenuItem value=""><em>Selecione</em></MenuItem>
                    <MenuItem value="boleto">Boleto</MenuItem>
                    <MenuItem value="carne">Carnê</MenuItem>
                  </Select>
	                  {fieldErrors.formaPagamento && <FormHelperText>Selecione boleto ou carnê</FormHelperText>}
	                </FormControl>
	                <FormControlLabel
	                  sx={{ mb: 2 }}
	                  control={
	                    <Checkbox
	                      checked={Boolean(formData.contratoAssinado)}
	                      onChange={e => handleInputChange("contratoAssinado", e.target.checked)}
	                    />
	                  }
	                  label="Contrato assinado"
	                />
              </FieldGroup>
            </FieldRow>

            <FieldRow>
              <FieldGroup xs={12}>
                <FieldLabel>
                  Conforme solicitação do Ministério da Educação, através da
                  Portaria INPE 156 de 20/10/04, indique a cor/raça do aluno
                  para o Censo Escolar: *
                </FieldLabel>
                <FormControl fullWidth required error={fieldErrors.corRaca}>
                  <Select id="requerimento-campo-corRaca"
                    value={formData.corRaca}
                    onChange={(e) =>
                      handleInputChange("corRaca", e.target.value)
                    }
                    displayEmpty
                  >
                    <MenuItem value="">
                      <em>Selecione</em>
                    </MenuItem>
                    <MenuItem value="branca">BRANCA</MenuItem>
                    <MenuItem value="preta">PRETA</MenuItem>
                    <MenuItem value="parda">PARDA</MenuItem>
                    <MenuItem value="amarela">AMARELA</MenuItem>
                    <MenuItem value="indigena">INDÍGENA</MenuItem>
                    <MenuItem value="nao_declarada">NÃO DECLARADA</MenuItem>
                  </Select>
                  {fieldErrors.corRaca && (
                    <FormHelperText error>Campo obrigatório</FormHelperText>
                  )}
                </FormControl>
              </FieldGroup>
            </FieldRow>
	          </RequerimentoSection>

	          <RequerimentoSection key={`${formSession}-documentos`} sectionId="documentos" pending={pendingBySection.documentos} onComplete={advanceToNextRequired} openRequest={sectionOpenRequest.id === "documentos" ? sectionOpenRequest.token : 0}>
	            <FieldRow>
		              <FieldGroup xs={12}>
		                <FieldLabel>Contrato e assinatura digital</FieldLabel>
		                <Box sx={{ display: "flex", gap: 2, flexWrap: "wrap", alignItems: "center", mb: 1 }}>
		                  <Button variant="outlined" component="label">
		                    Importar contrato PDF
	                    <input
	                      type="file"
	                      hidden
	                      accept="application/pdf"
		                      onChange={(event) => setContractPdfFile(event.target.files?.[0] || null)}
		                    />
		                  </Button>
		                  <Button variant="outlined" onClick={() => openSignatureModal("financial")}>
		                    Assinar responsável financeiro
		                  </Button>
		                  <Button
		                    variant="outlined"
		                    onClick={() => openSignatureModal("pedagogical")}
		                    disabled={useFinancialSignatureForPedagogical}
		                  >
		                    Assinar responsável pedagógico
		                  </Button>
		                </Box>
		                <FormControlLabel
		                  control={
		                    <Checkbox
		                      checked={useFinancialSignatureForPedagogical}
		                      onChange={(event) => setUseFinancialSignatureForPedagogical(event.target.checked)}
		                    />
		                  }
		                  label="Responsável pedagógico é o mesmo do financeiro"
		                />
		                <Box sx={{ display: "flex", gap: 2, flexWrap: "wrap", mt: 1 }}>
		                  {financialSignatureImageData && <Typography variant="body2" color="success.main">Assinatura financeira coletada</Typography>}
		                  {getEffectivePedagogicalSignature() && <Typography variant="body2" color="success.main">Assinatura pedagógica definida</Typography>}
		                </Box>
		                {contractPdfFile && (
		                  <Typography variant="body2" color="text.secondary">
	                    Contrato importado: {contractPdfFile.name}
	                  </Typography>
	                )}
	              </FieldGroup>
	            </FieldRow>
	          </RequerimentoSection>

	          {/* Botões de Ação */}
	          <ButtonContainer>
            <ButtonGroup>
              <Button
                variant="contained"
                color="primary"
                size="large"
                onClick={handleSubmit}
                disabled={loading || studentLoading}
                sx={{ minWidth: 200 }}
              >
                {loading ? "Atualizando..." : "Atualizar Dados"}
              </Button>
              <Button
                variant="outlined"
                color="secondary"
                size="large"
                onClick={handleGeneratePDF}
                disabled={loading || studentLoading}
                sx={{ minWidth: 200 }}
              >
                Gerar PDF
              </Button>
              <Button
                variant="outlined"
                color="secondary"
                size="large"
                onClick={() => setShowClearConfirmation(true)}
                disabled={loading || studentLoading}
                sx={{ minWidth: 200 }}
              >
                Limpar Formulário
              </Button>
            </ButtonGroup>
          </ButtonContainer>
        </Paper>
	      </FormContainer>

        <Dialog open={showClearConfirmation} onClose={() => setShowClearConfirmation(false)} aria-labelledby="limpar-requerimento-title">
          <DialogTitle id="limpar-requerimento-title">Limpar requerimento?</DialogTitle>
          <DialogContent>Os campos e as assinaturas desta tela serão limpos. Isso não altera os dados já salvos na Sponte.</DialogContent>
          <DialogActions>
            <Button onClick={() => setShowClearConfirmation(false)}>Continuar preenchendo</Button>
            <Button color="error" onClick={() => { clearForm(); setShowClearConfirmation(false); }}>Confirmar limpeza</Button>
          </DialogActions>
        </Dialog>

	      <Dialog open={showSignatureModal} onClose={() => setShowSignatureModal(false)} fullWidth maxWidth="lg">
	        <DialogTitle sx={{ pb: 1 }}>
	          Assinatura digital do responsável {activeSignatureType === "pedagogical" ? "pedagógico" : "financeiro"}
	        </DialogTitle>
	        <DialogContent dividers sx={{ pt: 2.5 }}>
	          <Box sx={{ display: "flex", justifyContent: "space-between", gap: 2, flexWrap: "wrap", mb: 2 }}>
		            <Typography variant="body2" color="text.secondary">
		              Assine com movimento natural sobre a área branca.
		            </Typography>
		            <Typography variant="caption" color="text.secondary">
		              Traço fiel em alta resolução
	            </Typography>
	          </Box>
	          <Box sx={{
	            position: "relative",
	            height: { xs: 364, sm: 442 },
	            border: "1px solid #c7ced8",
	            borderRadius: 2,
	            backgroundColor: "#fff",
	            boxShadow: "inset 0 1px 3px rgba(15, 23, 42, 0.08)",
	            overflow: "hidden",
	          }}>
	            <Box sx={{
	              position: "absolute",
	              left: "8%",
	              right: "8%",
	              top: "64%",
	              borderTop: "2px solid #7b8794",
	            }} />
	            <Typography
	              variant="caption"
	              color="text.secondary"
	              sx={{ position: "absolute", left: "8%", top: "68%", userSelect: "none" }}
	            >
	              linha guia
	            </Typography>
	            <Box
		              component="canvas"
		              ref={signatureCanvasRef}
		            onPointerDown={startSignature}
	            onPointerMove={drawSignature}
	            onPointerUp={stopSignature}
	            onPointerCancel={stopSignature}
	            onPointerLeave={stopSignature}
	            sx={{
	              width: "100%",
		              height: "100%",
		              display: "block",
		              cursor: "crosshair",
		              touchAction: "none",
                  imageRendering: "auto",
		            }}
	            />
	          </Box>
	        </DialogContent>
	        <DialogActions sx={{ px: 3, py: 2 }}>
	          <Button onClick={clearSignatureCanvas}>Limpar assinatura</Button>
	          <Button onClick={() => setShowSignatureModal(false)}>Cancelar</Button>
	          <Button variant="contained" onClick={saveSignatureCanvas}>Usar assinatura</Button>
	        </DialogActions>
	      </Dialog>

	      {/* Modal de Confirmação para PDF com Campos Faltando */}
	      <Dialog
        open={showPdfConfirmModal}
        onClose={() => setShowPdfConfirmModal(false)}
        maxWidth="md"
        fullWidth
      >
        <DialogTitle>
          <Typography component="span" variant="h6" color="warning.main">
            ⚠️ Campos Obrigatórios Não Preenchidos
          </Typography>
        </DialogTitle>
        <DialogContent>
          <Typography variant="body1" sx={{ mb: 2 }}>
            Os seguintes campos obrigatórios não foram preenchidos:
          </Typography>
          <List dense>
            {pdfValidationResult?.missingFields?.map((field, index) => (
              <ListItem key={index}>
                <ListItemText
                  primary={`• ${field}`}
                  sx={{ color: "error.main" }}
                />
              </ListItem>
            ))}
          </List>
          <Typography variant="body2" sx={{ mt: 2, color: "text.secondary" }}>
            Você pode gerar o PDF mesmo assim, mas os campos não preenchidos
            aparecerão em branco no documento.
          </Typography>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setShowPdfConfirmModal(false)} color="primary">
            Cancelar
          </Button>
          <Button
            onClick={async () => {
              if (!validateRequiredChoices()) return;
              setShowPdfConfirmModal(false);
              await generatePDFWithStatus();
            }}
            color="warning"
            variant="contained"
          >
            Gerar PDF Mesmo Assim
          </Button>
        </DialogActions>
      </Dialog>

      {/* Modal de Confirmação para Atualização com Campos Faltando */}
      <Dialog
        open={showUpdateConfirmModal}
        onClose={() => setShowUpdateConfirmModal(false)}
        maxWidth="md"
        fullWidth
      >
        <DialogTitle>
          <Typography component="span" variant="h6" color="warning.main">
            ⚠️ Campos Obrigatórios Não Preenchidos
          </Typography>
        </DialogTitle>
        <DialogContent>
          <Typography variant="body1" sx={{ mb: 2 }}>
            Os seguintes campos obrigatórios não foram preenchidos:
          </Typography>
          <List dense>
            {updateValidationResult?.missingFields?.map((field, index) => (
              <ListItem key={index}>
                <ListItemText
                  primary={`• ${field}`}
                  sx={{ color: "error.main" }}
                />
              </ListItem>
            ))}
          </List>
          <Typography variant="body2" sx={{ mt: 2, color: "text.secondary" }}>
            Você pode atualizar os dados mesmo assim, mas os campos não preenchidos
            não serão salvos no sistema.
          </Typography>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setShowUpdateConfirmModal(false)} color="primary">
            Cancelar
          </Button>
          <Button
            onClick={executeUpdate}
            color="warning"
            variant="contained"
          >
            Atualizar Mesmo Assim
          </Button>
        </DialogActions>
      </Dialog>

	      <Snackbar
	        open={error}
	        autoHideDuration={5000}
	        onClose={handleClose}
	        anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
	        sx={{ mb: { xs: 2, sm: 3 } }}
	      >
        <Alert
          variant="filled"
          onClose={handleClose}
          severity={typeError}
          sx={{ width: "100%" }}
        >
          {errorMessage}
        </Alert>
      </Snackbar>

      {loading && <Loading />}
    </Container>
  );
};
